import { useEffect, useMemo, useRef, useState } from 'react';
import { FormasiBanDraggable } from './FormasiBanDraggable';
import { backendPort } from '../components/Fungsiku';
import api from "../services/axiosInstance";
import { ShowPic } from '../components/ShowPic';
import { PageKonten9_Pict } from "./Page9_Pict";
import { PageKonten15OdoTd } from "./Page25_UpdateData";
import { useNotification } from './NotifPopup';
import { ModalCariBanMulti } from "./Page27_Cari";

const REQ_GROUP_ROTASI_DAFTAR_BAN = "rotasi-daftar-ban";
const REQ_GROUP_ROTASI_BAN_META = "rotasi-ban-meta";
const REQ_GROUP_ROTASI_BAN_EVENT = "rotasi-ban-event";
const REQ_GROUP_ROTASI_HISTORY_MT = "rotasi-history-mt";
const REQ_GROUP_ROTASI_POSISI_HISTORY = "rotasi-posisi-history";
const REQ_GROUP_ROTASI_SUBMIT = "rotasi-submit";
const REQ_GROUP_ROTASI_MT_PROFIL = "rotasi-mt-profil";
const REQ_GROUP_ROTASI_KMT_OTF = "rotasi-kmt-otf";
const REQ_GROUP_ROTASI_TAMBAL_OPSI = "rotasi-tambal-opsi";
const REQ_GROUP_ROTASI_STORING_LAST_CHECK = "rotasi-storing-last-check";
const FORCED_LOCATION_GUDANG_ONLY = Object.freeze(["gudang"]);
const BLOCKED_LOCATIONS_NON_GUDANG = Object.freeze(["otf", "pabrik"]);
const BAN_DEFECT_OPTIONS = Object.freeze([
  {
    label: "Normal",
    definition: "Aus normal/tidak ada kerusakan",
  },
  {
    label: "Aus Dini",
    definition: "Ban Aus lebih cepat dari standar yang ditentukan perusahaan.",
  },
  {
    label: "Aus Tidak Merata",
    definition: "Aus hanya di satu sisi atau di titik tertentu.",
  },
  {
    label: "Run Flat",
    definition: "Ban hancur karena dipaksa berjalan saat kempis.",
  },
  {
    label: "Underinflation",
    definition: "Kerusakan pada dinding samping akibat panas berlebih karena tekanan udara terlalu rendah.",
  },
  {
    label: "Overinflation",
    definition: "Pecah tiba-tiba karena ban tidak mampu menahan tekanan.",
  },
  {
    label: "Chipping/Chunking",
    definition: "Serpihan karet telapak terlepas/rusak akibat sering melewati jalan berbatu tajam.",
  },
  {
    label: "Rib Punch",
    definition: "Luka robek memanjang pada alur ban.",
  },
  {
    label: "Sidewall Cut",
    definition: "Luka sayat pada area samping akibat gesekan dengan trotoar atau benda tajam.",
  },
  {
    label: "Bulging",
    definition: "Benjolan pada dinding ban akibat putusnya benang nilon/kawat di dalam casing.",
  },
  {
    label: "Bead Burn",
    definition: "Kerusakan karet di area bead (area dekat velg) akibat panas berlebih dari sistem pengereman.",
  },
  {
    label: "Bead Deformity",
    definition: "Perubahan bentuk kawat bead (area dekat velg) akibat kesalahan saat proses bongkar pasang ban.",
  },
  {
    label: "Chafed Bead",
    definition: "Kerusakan akibat gesekan antara ban dengan velg yang tidak pas.",
  },
  {
    label: "Separation",
    definition: "Terlepasnya lapisan antara karet dengan kawat.",
  },
  {
    label: "Inner Liner Porosity",
    definition: "Kebocoran halus pada lapisan dalam sehingga udara masuk ke sela-sela casing.",
  },
]);
const BAN_MECHANICAL_INDICATION_OPTIONS = Object.freeze([
  { label: "Normal", definition: "Tidak ada penyebab kerusakan mekanik yang teridentifikasi." },
  { label: "Toe (In/Out)", definition: "Kondisi di mana sudut roda masuk ke dalam atau keluar jika dilihat dari atas. Ini menyebabkan ban terseret secara menyamping (Scuffing), mengakibatkan aus pada sisi luar atau dalam telapak ban." },
  { label: "Chamber (+/-)", definition: "Kemiringan roda ke arah dalam atau luar jika dilihat dari depan. Hal ini menyebabkan beban ban terkonsentrasi hanya pada satu sisi (One-sided wear)." },
  { label: "Kondisi Velg", definition: "Velg peyang, retak, atau berkarat yang berdampak kebocoran udara halus atau membuat bead ban tidak duduk sempurna (Bead damage)." },
  { label: "Kondisi Suspensi", definition: "Suspensi mati/keras sehingga ban tidak bisa menapak dengan stabil saat melewati gundukan, menciptakan pola keausan bergelombang." },
  { label: "Kondisi Bearing", definition: "Bearing longgar atau aus menyebabkan roda \"goyang\" saat berputar, yang berdampak ban mengalami Spot Wear atau keausan yang tidak beraturan di beberapa titik." },
  { label: "Intensitas Pengereman Tinggi/Tidak Normal", definition: "Menyebabkan panas berlebih yang merambat dari tromol ke velg, mengakibatkan Bead Burn (karet bead mengeras/pecah) atau Rem yang macet yang menyebabkan ban terus terseret, memicu panas berlebih dan keausan yang sangat cepat." },
]);

function ModalRepairDetail({ open, row, attachments = [], opsiJenisTambal = [], opsiBahanTambal = [], onClose, onSave }) {
  const [form, setForm] = useState({
    jenis_tambal: '',
    bahan_tambal: '',
    qty_tambal: 0,
    catatan: '',
  });
  const [draftAttachments, setDraftAttachments] = useState([]);
  const [invalidAttachmentIndexes, setInvalidAttachmentIndexes] = useState([]);

  useEffect(() => {
    if (!open) return;
    setForm({
      jenis_tambal: String(row?.jenis_tambal || '').trim(),
      bahan_tambal: String(row?.bahan_tambal || '').trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      catatan: String(row?.catatan || ''),
    });
    setDraftAttachments((Array.isArray(attachments) ? attachments : []).map((item) => ({ ...(item || {}) })));
    setInvalidAttachmentIndexes([]);
  }, [open, row, attachments]);

  const qtyTambal = Number(form.qty_tambal);
  const invalidJenisTambal = !String(form.jenis_tambal || '').trim();
  const invalidQtyTambal = !Number.isFinite(qtyTambal) || qtyTambal < 0 || qtyTambal > 4;
  if (!open) return null;

  return (
    <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
      <div className="page16-modal-card" style={{ width: 'min(720px, 94vw)' }}>
        <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
          <div>
            <h5 className="mb-1">Keterangan Repair / Tambal Ban</h5>
            <small className="text-muted">{`${String(row?.seri_ban || '-')} | ${String(row?.posisi || '-')}`}</small>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>Tutup</button>
        </div>
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Jenis Tambal</label>
            <select className={`form-select ${invalidJenisTambal ? 'field-required-invalid' : ''}`} value={form.jenis_tambal} onChange={(e) => setForm((prev) => ({ ...prev, jenis_tambal: e.target.value }))}>
              <option value="">Pilih Jenis Tambal</option>
              {opsiJenisTambal.map((item) => <option key={`repair-detail-jenis-${item}`} value={item}>{item}</option>)}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Quantity</label>
            <input type="number" min="0" max="4" step="1" className={`form-control ${invalidQtyTambal ? 'field-required-invalid' : ''}`} value={Number(form.qty_tambal || 0)} onChange={(e) => setForm((prev) => ({ ...prev, qty_tambal: Number(e.target.value || 0) }))} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Bahan</label>
            <select className="form-select" value={form.bahan_tambal} onChange={(e) => setForm((prev) => ({ ...prev, bahan_tambal: e.target.value }))}>
              <option value="">Pilih Bahan Tambal</option>
              {opsiBahanTambal.map((item) => <option key={`repair-detail-bahan-${item}`} value={item}>{item}</option>)}
            </select>
          </div>
          <div className="col-12">
            <label className="form-label">Catatan</label>
            <textarea rows={2} className="form-control" placeholder="Masukkan catatan tambal ban..." value={form.catatan} onChange={(e) => setForm((prev) => ({ ...prev, catatan: e.target.value }))} />
          </div>
          <div className="col-12 border-top pt-3">
            <div className="fw-semibold small mb-1">Upload Dokumen Lampiran Repair / Tambal Ban</div>
            <PageKonten9_Pict
              attachments={draftAttachments}
              setAttachments={setDraftAttachments}
              bisaInput={true}
              invalidCaptionIndexes={invalidAttachmentIndexes}
              onCaptionChange={() => setInvalidAttachmentIndexes([])}
            />
            {invalidAttachmentIndexes.length > 0 && (
              <small className="text-danger fw-semibold">Caption wajib diisi untuk setiap lampiran.</small>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Batal</button>
          <button type="button" className="btn btn-primary" disabled={invalidJenisTambal || invalidQtyTambal} onClick={() => {
            const invalidIndexes = draftAttachments
              .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
              .filter((idx) => idx >= 0);
            if (invalidIndexes.length > 0) {
              setInvalidAttachmentIndexes(invalidIndexes);
              return;
            }
            onSave?.({
              jenis_tambal: String(form.jenis_tambal || '').trim(),
              bahan_tambal: String(form.bahan_tambal || '').trim(),
              qty_tambal: Number(form.qty_tambal || 0),
              catatan: String(form.catatan || ''),
              attachments: draftAttachments.map((item) => ({ ...(item || {}) })),
            });
          }}>Simpan</button>
        </div>
      </div>
    </div>
  );
}

export function PageKonten32_Rotasi({globalOpsi, editData, authIdentity = {}, setShowDetail, setShowMaster, reloadToken = 0, onSubmitSuccess}) {
  const { showNotif } = useNotification();
  const rootRef = useRef(null);
  const gudangDragStartRef = useRef({ x: 0, y: 0 });
  const gudangDragMovedRef = useRef(false);
  const gudangDragMoveThreshold = 4;
  const opsiCabang = globalOpsi?.opsiCabang || [];
  const formatTglUntukUI = (value) => {
      if (!value) return "-";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "-";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
  };
  const formatYYYYMMDD = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const resolvePositiveNumber = (...values) => {
    for (const item of values) {
      const num = Number(item);
      if (Number.isFinite(num) && num > 0) return num;
    }
    return 0;
  };
  const inferMaxPosIndex = (mapObj = {}, prefix = "P-") => {
    const entries = Object.keys(mapObj || {});
    if (!entries.length) return 0;
    const normalizedPrefix = String(prefix || "").toUpperCase();
    let max = 0;
    entries.forEach((keyRaw) => {
      const key = String(keyRaw || "").trim().toUpperCase();
      if (!key.startsWith(normalizedPrefix)) return;
      const numPart = key.slice(normalizedPrefix.length);
      const num = Number(numPart);
      if (Number.isFinite(num) && num > max) max = num;
    });
    return max;
  };
  
  const daftarLampiran = Array.isArray(editData?.lampiran) ? editData.lampiran : [];
  const mapCabang = useMemo(() => {
    const out = {};
    (Array.isArray(opsiCabang) ? opsiCabang : []).forEach((row) => {
      const key = String(row?.kode_cabang || '').trim();
      if (!key) return;
      out[key] = String(row?.nama_cabang || '').trim() || key;
    });
    return out;
  }, [opsiCabang]);
  const [historyMtRows, setHistoryMtRows] = useState([]);
  const [loadingHistoryMt, setLoadingHistoryMt] = useState(false);
  const [showPosisiHistoryModal, setShowPosisiHistoryModal] = useState(false);
  const [loadingPosisiHistory, setLoadingPosisiHistory] = useState(false);
  const [posisiHistoryRows, setPosisiHistoryRows] = useState([]);
  const [selectedHistoryPosisi, setSelectedHistoryPosisi] = useState('');
  const [hoverBanTooltip, setHoverBanTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    owner: '',
    pos: '',
    id_ban: 0,
  });
  const [daftarBanMapMt1, setDaftarBanMapMt1] = useState({});
  const [daftarBanMapMt2, setDaftarBanMapMt2] = useState({});
  const [openPilihBanGudangModal, setOpenPilihBanGudangModal] = useState(false);
  const [selectedGudangBanRows, setSelectedGudangBanRows] = useState([]);
  const [selectedGudangBanIds, setSelectedGudangBanIds] = useState([]);
  const [dragMonitor, setDragMonitor] = useState({
    active: false,
    source: null,
    target: null,
    hasPair: false,
  });
  const [banMetaById, setBanMetaById] = useState({});
  const [kmtOtfByBanId, setKmtOtfByBanId] = useState({});
  const [gudangDrag, setGudangDrag] = useState({
    active: false,
    idBan: 0,
    seriBan: '',
    x: 0,
    y: 0,
    hasPair: false,
    target: null,
  });
  const [riwayatPerubahanRows, setRiwayatPerubahanRows] = useState([]);
  const [initialPlaceByBanId, setInitialPlaceByBanId] = useState({});
  const [baselineState, setBaselineState] = useState(null);
  const [mtProfileFallback, setMtProfileFallback] = useState({});
  const [mtProfileLoaded, setMtProfileLoaded] = useState(false);
  const [openStatusBanModal, setOpenStatusBanModal] = useState(false);
  const [statusBanTargetRow, setStatusBanTargetRow] = useState(null);
  const [statusBanDraftNext, setStatusBanDraftNext] = useState('');
  const [beritaAcaraByBanId, setBeritaAcaraByBanId] = useState({});
  const [invalidBeritaAcaraCaptionIndexesByBanId, setInvalidBeritaAcaraCaptionIndexesByBanId] = useState({});
  const [openKetLepasModal, setOpenKetLepasModal] = useState(false);
  const [ketLepasTargetRow, setKetLepasTargetRow] = useState(null);
  const [ketLepasDraft, setKetLepasDraft] = useState('');
  const [indikasiDraft, setIndikasiDraft] = useState('');
  const [catatanDraft, setCatatanDraft] = useState('');
  const [tindakLanjutDraft, setTindakLanjutDraft] = useState('');
  const [namaSopirDraft, setNamaSopirDraft] = useState('');
  const [defectTooltip, setDefectTooltip] = useState({
    visible: false,
    text: "",
    x: 0,
    y: 0,
  });
  const [openLampiranModal, setOpenLampiranModal] = useState(false);
  const [selectedLampiranFiles, setSelectedLampiranFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [invalidCaptionIndexes, setInvalidCaptionIndexes] = useState([]);
  const [repairRows, setRepairRows] = useState([]);
  const [repairAttachmentsByBanId, setRepairAttachmentsByBanId] = useState({});
  const [openRepairDetailModal, setOpenRepairDetailModal] = useState(false);
  const [activeRepairDetailBanId, setActiveRepairDetailBanId] = useState(0);
  const [opsiJenisTambal, setOpsiJenisTambal] = useState([]);
  const [opsiBahanTambal, setOpsiBahanTambal] = useState([]);
  const [storingLastCheckByMt, setStoringLastCheckByMt] = useState({});
  const [storingLastCheckLoading, setStoringLastCheckLoading] = useState(false);
  const [storingLastCheckRefreshTick, setStoringLastCheckRefreshTick] = useState(0);
  const [storingLastCheckModal, setStoringLastCheckModal] = useState({ action: '', idMt: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitLockRef = useRef(false);
  const [selectedCabang, setSelectedCabang] = useState(String(editData?.kode_cabang || '').trim());
  const jumlahMtTerkait = String(editData?.jumlah_mt || '').trim() === '2' || Number(editData?.jumlah_mt || 0) === 2 ? 2 : 1;
  const idMt1 = String(editData?.id_mt_1 || editData?.id_mt || '').trim();
  const idMt2 = String(editData?.id_mt_2 || '').trim();
  const isDualMt = jumlahMtTerkait === 2 && Boolean(idMt2);
  const mtRow1 = (Array.isArray(globalOpsi?.opsiMT) ? globalOpsi.opsiMT : [])
    .find((x) => String(x?.id_mt || '').trim() === idMt1) || null;
  const mtRow2 = (Array.isArray(globalOpsi?.opsiMT) ? globalOpsi.opsiMT : [])
    .find((x) => String(x?.id_mt || '').trim() === idMt2) || null;
  const inferredFormasiMt1 = inferMaxPosIndex(daftarBanMapMt1, "P-");
  const inferredCadanganMt1 = inferMaxPosIndex(daftarBanMapMt1, "S-");
  const inferredFormasiMt2 = inferMaxPosIndex(daftarBanMapMt2, "P-");
  const inferredCadanganMt2 = inferMaxPosIndex(daftarBanMapMt2, "S-");
  const formasiMt1 = mtProfileLoaded
    ? resolvePositiveNumber(
      mtProfileFallback?.[idMt1]?.roda,
      mtRow1?.roda,
      editData?.roda_1,
      editData?.roda,
      inferredFormasiMt1,
      16
    )
    : resolvePositiveNumber(
      inferredFormasiMt1,
      editData?.roda_1,
      editData?.roda,
      mtRow1?.roda,
      16
    );
  const cadanganMt1 = mtProfileLoaded
    ? resolvePositiveNumber(
      mtProfileFallback?.[idMt1]?.cadangan,
      mtRow1?.cadangan,
      editData?.cadangan_1,
      editData?.cadangan,
      inferredCadanganMt1,
      3
    )
    : resolvePositiveNumber(
      inferredCadanganMt1,
      editData?.cadangan_1,
      editData?.cadangan,
      mtRow1?.cadangan,
      3
    );
  const formasiMt2 = mtProfileLoaded
    ? resolvePositiveNumber(
      mtProfileFallback?.[idMt2]?.roda,
      mtRow2?.roda,
      editData?.roda_2,
      inferredFormasiMt2,
      formasiMt1
    )
    : resolvePositiveNumber(
      inferredFormasiMt2,
      editData?.roda_2,
      mtRow2?.roda,
      formasiMt1
    );
  const cadanganMt2 = mtProfileLoaded
    ? resolvePositiveNumber(
      mtProfileFallback?.[idMt2]?.cadangan,
      mtRow2?.cadangan,
      editData?.cadangan_2,
      inferredCadanganMt2,
      cadanganMt1
    )
    : resolvePositiveNumber(
      inferredCadanganMt2,
      editData?.cadangan_2,
      mtRow2?.cadangan,
      cadanganMt1
    );
  const mt1Info = `${String(editData?.id_mt_1 || editData?.id_mt || '-').trim() || '-'} | No Pol. ${String(editData?.nopol_1 || editData?.nopol || '-').trim() || '-'}`;
  const mt2Info = `${String(editData?.id_mt_2 || '-').trim() || '-'} | No Pol. ${String(editData?.nopol_2 || '-').trim() || '-'}`;
  const nopolMt1 = String(editData?.nopol_1 || editData?.nopol || '-').trim() || '-';
  const nopolMt2 = String(editData?.nopol_2 || '-').trim() || '-';
  const resolveNopolByIdMt = (idMtRaw) => {
    const idMt = String(idMtRaw || '').trim();
    if (!idMt) return '-';
    const opsi = Array.isArray(globalOpsi?.opsiMT) ? globalOpsi.opsiMT : [];
    const match = opsi.find((row) => String(row?.id_mt || '').trim() === idMt)
      || opsi.find((row) => String(row?.id_mt || '').trim().toLowerCase() === idMt.toLowerCase())
      || null;
    if (match) return String(match?.nopol || '').trim() || idMt;
    if (idMt === String(idMt1 || '').trim()) return nopolMt1;
    if (idMt === String(idMt2 || '').trim()) return nopolMt2;
    return idMt;
  };
  const namaCabangAktif = String(mapCabang?.[String(selectedCabang || '').trim()] || selectedCabang || '-').trim() || '-';
  const actorNama = String(authIdentity?.nama || '-').trim() || '-';
  const petugasInput = actorNama;
  const isStoringRotasiContext = String(editData?.context_mode || '').trim().toLowerCase() === 'storing_rotasi';
  const teksHeaderRotasi = isStoringRotasiContext
    ? (isDualMt
      ? `Aksi Storing untuk MT ${nopolMt1} dan ${nopolMt2} pada Cabang ${namaCabangAktif}.`
      : `Aksi Storing untuk MT ${nopolMt1} pada Cabang ${namaCabangAktif}.`)
    : (isDualMt
      ? `Aksi Rotasi/Ganti dan Repair Ban untuk MT ${nopolMt1} dan ${nopolMt2} pada Cabang ${namaCabangAktif}.`
      : `Aksi Rotasi/Ganti dan Repair Ban untuk MT ${nopolMt1} pada Cabang ${namaCabangAktif}.`);
  const targetMt1Pos = (
    dragMonitor?.active
    && String(dragMonitor?.target?.kind || '').trim() === 'slot'
    && String(dragMonitor?.target?.owner || '').trim() === 'mt1'
  ) ? String(dragMonitor?.target?.pos || '').trim() : '';
  const targetMt2Pos = (
    dragMonitor?.active
    && String(dragMonitor?.target?.kind || '').trim() === 'slot'
    && String(dragMonitor?.target?.owner || '').trim() === 'mt2'
  ) ? String(dragMonitor?.target?.pos || '').trim() : '';

  useEffect(() => {
    setSelectedCabang(String(editData?.kode_cabang || '').trim());
  }, [editData?.kode_cabang]);
  useEffect(() => {
    setBaselineState(null);
  }, [idMt1, idMt2, reloadToken]);
  useEffect(() => {
    let ignore = false;
    const loadMtProfileFallback = async () => {
      const ids = [String(idMt1 || "").trim(), String(idMt2 || "").trim()].filter(Boolean);
      if (!ids.length) {
        setMtProfileLoaded(true);
        setMtProfileFallback({});
        return;
      }
      try {
        setMtProfileLoaded(false);
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_MT_PROFIL, reason: "Refresh mt profil rotasi" });
        const { data } = await api.get(`${backendPort}/api/main/mt_profil`, {
          requestGroup: REQ_GROUP_ROTASI_MT_PROFIL,
          timeout: 120000,
        });
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        const byId = {};
        rows.forEach((row) => {
          const id = String(row?.id_mt || "").trim();
          if (!id || !ids.includes(id)) return;
          byId[id] = {
            roda: Number(row?.roda || 0),
            cadangan: Number(row?.cadangan || 0),
          };
        });
        setMtProfileFallback(byId);
        setMtProfileLoaded(true);
      } catch (err) {
        if (!api.isCanceledError?.(err)) console.error(err);
        if (!ignore) {
          setMtProfileFallback({});
          setMtProfileLoaded(true);
        }
      }
    };
    loadMtProfileFallback();
    return () => {
      ignore = true;
    };
  }, [idMt1, idMt2, reloadToken]);

  useEffect(() => {
    const host = rootRef.current;
    if (!host) return undefined;
    const dialog = host.closest('.modal-dialog');
    if (!dialog) return undefined;
    const content = host.closest('.modal-content');

    const prevWidth = dialog.style.width;
    const prevMaxWidth = dialog.style.maxWidth;
    const prevHeight = dialog.style.height;
    const prevMaxHeight = dialog.style.maxHeight;
    const prevMargin = dialog.style.margin;
    const prevContentHeight = content?.style.height || '';
    const prevContentMaxHeight = content?.style.maxHeight || '';
    const targetWidth = '100vw';
    dialog.style.width = targetWidth;
    dialog.style.maxWidth = targetWidth;
    dialog.style.height = '100vh';
    dialog.style.maxHeight = '100vh';
    dialog.style.margin = '0';
    if (content) {
      content.style.height = '100vh';
      content.style.maxHeight = '100vh';
    }

    return () => {
      dialog.style.width = prevWidth;
      dialog.style.maxWidth = prevMaxWidth;
      dialog.style.height = prevHeight;
      dialog.style.maxHeight = prevMaxHeight;
      dialog.style.margin = prevMargin;
      if (content) {
        content.style.height = prevContentHeight;
        content.style.maxHeight = prevContentMaxHeight;
      }
    };
  }, [isDualMt]);

  useEffect(() => {
    let ignore = false;
    const parseDaftarBan = (raw) => {
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw || '{}') || {};
        } catch {
          return {};
        }
      }
      if (raw && typeof raw === 'object') return raw;
      return {};
    };
    const loadDaftarBanByMt = async (idMt) => {
      const id = String(idMt || '').trim();
      if (!id) return {};
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_daftarkodeban/${id}`, {
          requestGroup: REQ_GROUP_ROTASI_DAFTAR_BAN,
          timeout: 120000,
        });
        return parseDaftarBan(data);
      } catch {
        return {};
      }
    };
    const loadDaftarBan = async () => {
      if (!idMt1) {
        setDaftarBanMapMt1({});
        setDaftarBanMapMt2({});
        return;
      }
      api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_DAFTAR_BAN, reason: 'Refresh daftar ban mt rotasi' });
      const [map1, map2] = await Promise.all([
        loadDaftarBanByMt(idMt1),
        isDualMt ? loadDaftarBanByMt(idMt2) : Promise.resolve({})
      ]);
      if (ignore) return;
      setDaftarBanMapMt1(map1 || {});
      setDaftarBanMapMt2(map2 || {});
    };
    loadDaftarBan();
    return () => {
      ignore = true;
    };
  }, [idMt1, idMt2, isDualMt, reloadToken]);

  useEffect(() => {
    let ignore = false;
    api.get(`${backendPort}/api/main/load_opsi_tambahan_tambal`, {
      requestGroup: REQ_GROUP_ROTASI_TAMBAL_OPSI,
      timeout: 30000,
    }).then(({ data }) => {
      if (ignore) return;
      setOpsiJenisTambal(Array.isArray(data?.opsiJenisTambal) ? data.opsiJenisTambal : []);
      setOpsiBahanTambal(Array.isArray(data?.opsiBahanTambal) ? data.opsiBahanTambal : []);
    }).catch((err) => {
      if (!api.isCanceledError?.(err)) console.error('Gagal memuat opsi tambal rotasi:', err);
      if (!ignore) {
        setOpsiJenisTambal([]);
        setOpsiBahanTambal([]);
      }
    });
    return () => {
      ignore = true;
      api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_TAMBAL_OPSI, reason: 'Rotasi modal ditutup' });
    };
  }, []);

  useEffect(() => {
    const mergeMeta = (rows = []) => {
      if (!Array.isArray(rows) || rows.length === 0) return;
      setBanMetaById((prev) => {
        const next = { ...(prev || {}) };
        rows.forEach((row) => {
          const idBan = Number(row?.id_ban || row?.id || 0);
          if (!idBan) return;
          const seri = String(row?.seri_ban || row?.seri || '').trim();
          if (!seri) return;
          next[idBan] = {
            ...(next[idBan] || {}),
            id_ban: idBan,
            seri_ban: seri,
            status: String(row?.status || row?.status_terakhir || '').trim(),
          };
        });
        return next;
      });
    };
    mergeMeta(selectedGudangBanRows);
  }, [selectedGudangBanRows]);

  useEffect(() => {
    let ignore = false;
    const loadBanMetaFromFormasi = async () => {
      const ids = Array.from(new Set(
        [...Object.values(daftarBanMapMt1 || {}), ...Object.values(daftarBanMapMt2 || {})]
          .map((x) => Number(x || 0))
          .filter((x) => Number.isFinite(x) && x > 0)
      ));
      if (!ids.length) return;
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_BAN_META, reason: 'Refresh ban meta rotasi' });
        const { data } = await api.post(
          `${backendPort}/api/main/load_daftarBanThisMT_initial`,
          { kodeBan: ids },
          {
            requestGroup: REQ_GROUP_ROTASI_BAN_META,
            timeout: 120000,
          }
        );
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        setBanMetaById((prev) => {
          const next = { ...(prev || {}) };
          rows.forEach((row) => {
            const idBan = Number(row?.id_ban || row?.id || 0);
            if (!idBan) return;
            next[idBan] = {
              ...(next[idBan] || {}),
              id_ban: idBan,
              seri_ban: String(row?.seri_ban || row?.seri || next?.[idBan]?.seri_ban || '').trim(),
              km_tempuh: Number(row?.kmt_profil || next?.[idBan]?.km_tempuh || 0) || 0,
              td: String(row?.td_profil || next?.[idBan]?.td || '').trim(),
            };
          });
          return next;
        });
      } catch (err) {
        if (!api.isCanceledError?.(err)) console.error(err);
      }
    };
    loadBanMetaFromFormasi();
    return () => {
      ignore = true;
    };
  }, [daftarBanMapMt1, daftarBanMapMt2]);
  useEffect(() => {
    let ignore = false;
    const ids = Array.from(new Set(
      [
        ...Object.values(daftarBanMapMt1 || {}),
        ...Object.values(daftarBanMapMt2 || {}),
        ...(selectedGudangBanRows || []).map((row) => row?.id_ban),
      ]
        .map((x) => Number(x || 0))
        .filter((x) => Number.isFinite(x) && x > 0)
    ));
    if (!ids.length) return undefined;
    (async () => {
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_BAN_EVENT, reason: 'Refresh event ban rotasi' });
        const { data } = await api.post(
          `${backendPort}/api/main/load_ban_event_history_by_ban`,
          {
            kodeBan: ids,
            latestOnly: true,
          },
          {
            requestGroup: REQ_GROUP_ROTASI_BAN_EVENT,
            timeout: 120000,
          }
        );
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        if (!rows.length) return;
        setBanMetaById((prev) => {
          const next = { ...(prev || {}) };
          rows.forEach((row) => {
            const idBan = Number(row?.id_ban || 0);
            if (!idBan) return;
            next[idBan] = {
              ...(next[idBan] || {}),
              id_ban: idBan,
              status: String(row?.status || next?.[idBan]?.status || '').trim(),
              km_tempuh: Number(next?.[idBan]?.km_tempuh || row?.kmt || 0) || 0,
              td: String(next?.[idBan]?.td || row?.td || '').trim(),
            };
          });
          return next;
        });
      } catch (err) {
        if (!api.isCanceledError?.(err)) console.error(err);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [daftarBanMapMt1, daftarBanMapMt2, selectedGudangBanRows]);
  useEffect(() => {
    if (!dragMonitor?.active && !gudangDrag?.active) return;
    hideBanTooltip();
  }, [dragMonitor?.active, gudangDrag?.active]);
  useEffect(() => {
    if (!openKetLepasModal && defectTooltip.visible) {
      setDefectTooltip({ visible: false, text: "", x: 0, y: 0 });
    }
  }, [openKetLepasModal, defectTooltip.visible]);
  useEffect(() => {
    const onMouseMove = (event) => {
      if (!hoverBanTooltip?.visible) return;
      const hit = event?.target;
      const inBanHover = Boolean(hit?.closest?.('[data-ban-hover="1"]'));
      if (!inBanHover) hideBanTooltip();
    };
    window.addEventListener('mousemove', onMouseMove);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, [hoverBanTooltip?.visible]);

  useEffect(() => {
    let ignore = false;
    const loadHistoryMt = async () => {
      const idMt = idMt1;
      if (!idMt) {
        setHistoryMtRows([]);
        return;
      }
      setLoadingHistoryMt(true);
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_HISTORY_MT, reason: 'Refresh history mt rotasi' });
        const { data } = await api.get(`${backendPort}/api/main/load_mt_event_history/${idMt}`, {
          requestGroup: REQ_GROUP_ROTASI_HISTORY_MT,
          timeout: 30000,
        });
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        setHistoryMtRows(rows);
      } catch {
        if (!ignore) setHistoryMtRows([]);
      } finally {
        if (!ignore) setLoadingHistoryMt(false);
      }
    };
    loadHistoryMt();
    return () => {
      ignore = true;
    };
  }, [idMt1, reloadToken]);

  const historyRows = useMemo(() => {
    const parseReff = (raw) => {
      if (!raw) return {};
      if (typeof raw === 'string') {
        try { return JSON.parse(raw || '{}') || {}; } catch { return {}; }
      }
      if (typeof raw === 'object') return raw;
      return {};
    };
    const toCabangName = (kodeRaw) => {
      const kode = String(kodeRaw || '').trim();
      if (!kode) return '-';
      return opsiCabang.find((x) => String(x?.kode_cabang || '').trim() === kode)?.nama_cabang || kode;
    };
    const normalizeReffValue = (value) => {
      if (value == null) return '';
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value).trim();
      }
      if (Array.isArray(value)) {
        return value.map((x) => normalizeReffValue(x)).filter(Boolean).join(', ');
      }
      if (typeof value === 'object') {
        const entries = Object.entries(value)
          .map(([k, v]) => {
            const val = normalizeReffValue(v);
            return val ? `${k}:${val}` : '';
          })
          .filter(Boolean);
        return entries.join(', ');
      }
      return '';
    };
    const parseMovePairs = (value) => String(value || '')
      .split(',')
      .map((part) => String(part || '').trim())
      .filter(Boolean)
      .map((item) => {
        const seg = item.split('#');
        return {
          raw: item,
          a: String(seg[0] || '').trim(),
          b: String(seg[1] || '').trim(),
          c: String(seg[2] || '').trim(),
        };
      });
    const buildInfo = (row, reff) => {
      const eventName = String(row?.event_mt || '').toLowerCase();
      const beforeRaw = normalizeReffValue(reff?.before);
      const afterRaw = normalizeReffValue(reff?.after);
      const before = String(beforeRaw || '').trim();
      const after = String(afterRaw || '').trim();
      if (eventName.includes('initial') || eventName.includes('migrasi')) {
        const nomor = String(reff?.nomor || '').trim();
        if (nomor) return `Nomor: ${nomor}`;
      }
      if (eventName.includes('mutasi')) {
        const from = toCabangName(reff?.pengirim);
        const to = toCabangName(reff?.penerima);
        if (from !== '-' || to !== '-') return `${from} >>> ${to}`;
      }
      if (eventName.includes('ubah_seriban')) {
        const b = normalizeReffValue(reff?.before?.seri_ban ?? reff?.before);
        const a = normalizeReffValue(reff?.after?.seri_ban ?? reff?.after);
        return `${b || '-'} >>> ${a || '-'}`;
      }
      if (eventName.includes('ubah_nopol')) {
        const b = normalizeReffValue(reff?.before?.nopol ?? reff?.before);
        const a = normalizeReffValue(reff?.after?.nopol ?? reff?.after);
        return `${b || '-'} >>> ${a || '-'}`;
      }
      if (eventName === 'rotasi') {
        const beforePairs = parseMovePairs(reff?.before);
        const afterPairs = parseMovePairs(reff?.after);
        const source = beforePairs?.[0] || {};
        const from = String(source?.a || '').trim();
        const idBan = String(source?.b || '').trim();
        const targetById = afterPairs.find((x) => String(x?.b || '').trim() === idBan);
        const targetFallback = afterPairs.find((x) => String(x?.a || '').trim() !== from);
        const to = String(targetById?.a || targetFallback?.a || '').trim();
        if (from || to) return `${from || '-'} >>> ${to || '-'}`;
      }
      if (eventName === 'rotasi2') {
        const beforePairs = parseMovePairs(reff?.before);
        const afterPairs = parseMovePairs(reff?.after);
        const source = beforePairs?.[0] || {};
        const sourceMt = String(source?.a || '').trim();
        const sourcePos = String(source?.b || '').trim();
        const idBan = String(source?.c || '').trim();
        const from = (sourceMt && sourcePos) ? `${sourceMt}#${sourcePos}` : '';
        const targetById = afterPairs.find((x) => String(x?.c || '').trim() === idBan);
        const targetFallback = afterPairs.find((x) => {
          const mt = String(x?.a || '').trim();
          const pos = String(x?.b || '').trim();
          return `${mt}#${pos}` !== from;
        });
        const targetMt = String(targetById?.a || targetFallback?.a || '').trim();
        const targetPos = String(targetById?.b || targetFallback?.b || '').trim();
        const to = (targetMt && targetPos) ? `${targetMt}#${targetPos}` : '';
        if (from || to) return `${from || '-'} >>> ${to || '-'}`;
      }
      if (eventName.includes('ganti_ban')) {
        const left = before.split(',')[0] || before;
        const right = after.split(',')[0] || after;
        if (left || right) return `${left || '-'} >>> ${right || '-'}`;
      }
      if ((eventName.includes('rotasi') || eventName.includes('lepas_ban') || eventName.includes('pasang_ban')) && (before || after)) {
        return `${before || '-'} >>> ${after || '-'}`;
      }
      if (eventName.includes('tambal')) {
        const banTerdampak = String(row?.ban_terdampak || '').trim();
        if (banTerdampak) return banTerdampak;
        const patch = Number(reff?.patch || 0);
        if (Number.isFinite(patch) && patch > 0) return `Patch: ${patch}`;
      }
      if (eventName.startsWith('storing_')) {
        const banTerdampakDb = String(row?.ban_terdampak || '').trim();
        const banTerdampakReffRaw = reff?.['ban terdampak'];
        const banTerdampakReff = Array.isArray(banTerdampakReffRaw)
          ? banTerdampakReffRaw.map((x) => String(x || '').trim()).filter(Boolean).join(', ')
          : String(banTerdampakReffRaw || '').trim();
        const banTerdampak = banTerdampakDb || banTerdampakReff;
        if (banTerdampak) return banTerdampak;
        const catatan = String(reff?.catatan || '').trim();
        if (catatan) return catatan;
      }
      if (eventName.includes('ganti_odo')) {
        const lepas = reff?.odolepas;
        const pasang = reff?.odopasang;
        if (lepas != null || pasang != null) return `${lepas ?? '-'} >>> ${pasang ?? '-'}`;
      }
      if ((eventName.includes('ubah_') || eventName.includes('ganti_')) && (before || after)) {
        return `${before || '-'} >>> ${after || '-'}`;
      }
      if (before || after) return `${before || '-'} >>> ${after || '-'}`;
      const catatan = String(reff?.catatan || '').trim();
      if (catatan) return catatan;
      return '-';
    };

    return historyMtRows.map((row) => {
      const eventName = String(row?.event_mt || '-').toLowerCase();
      const reffObj = parseReff(row?.reff);
      let variant = 'neutral';
      if (eventName.includes('initial') || eventName.includes('migrasi')) variant = 'ok';
      else if (eventName.includes('mutasi') || eventName.includes('rotasi')) variant = 'alert';
      else if (eventName.includes('tambal') || eventName.includes('storing')) variant = 'link';

      return {
        label: String(row?.event_mt || '-').toUpperCase(),
        value: formatTglUntukUI(row?.tanggal),
        odo: Number(row?.odo || 0),
        kmtotal: Number(row?.kmtotal || 0),
        info: buildInfo(row, reffObj),
        variant
      };
    });
  }, [historyMtRows, opsiCabang]);
  const getEventVariant = (eventRaw) => {
    const eventName = String(eventRaw || '-').toLowerCase();
    if (eventName.includes('initial') || eventName.includes('migrasi')) return 'ok';
    if (eventName.includes('mutasi') || eventName.includes('rotasi')) return 'alert';
    if (eventName.includes('tambal') || eventName.includes('storing')) return 'link';
    return 'neutral';
  };

  const posisiList = useMemo(() => {
    const p = [];
    const maxP = Number.isFinite(formasiMt1) && formasiMt1 > 0 ? formasiMt1 : 0;
    for (let i = 1; i <= maxP; i += 1) {
      p.push(`P-${String(i).padStart(2, '0')}`);
    }
    const s = [];
    const maxS = Number.isFinite(cadanganMt1) && cadanganMt1 > 0 ? cadanganMt1 : 0;
    for (let i = 1; i <= maxS; i += 1) {
      s.push(`S-${i}`);
    }
    return [...p, ...s];
  }, [formasiMt1, cadanganMt1]);

  const posisiHistoryMap = useMemo(() => {
    const grouped = {};
    (Array.isArray(posisiHistoryRows) ? posisiHistoryRows : []).forEach((row) => {
      const posisi = String(row?.posisi || '').trim();
      if (!posisi) return;
      if (!grouped[posisi]) grouped[posisi] = [];
      grouped[posisi].push(row);
    });
    return grouped;
  }, [posisiHistoryRows]);

  useEffect(() => {
    if (!showPosisiHistoryModal) return;
    const idMt = idMt1;
    if (!idMt) {
      setPosisiHistoryRows([]);
      return;
    }
    let ignore = false;
    (async () => {
      setLoadingPosisiHistory(true);
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_POSISI_HISTORY, reason: 'Refresh history posisi rotasi' });
        const { data } = await api.get(`${backendPort}/api/main/load_ban_history_per_posisi_mt/${idMt}`, {
          requestGroup: REQ_GROUP_ROTASI_POSISI_HISTORY,
          timeout: 30000,
        });
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        setPosisiHistoryRows(rows);
      } catch {
        if (!ignore) setPosisiHistoryRows([]);
      } finally {
        if (!ignore) setLoadingPosisiHistory(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [showPosisiHistoryModal, idMt1, reloadToken]);

  useEffect(() => {
    if (!showPosisiHistoryModal) return;
    const activeHasData = Boolean(posisiHistoryMap?.[selectedHistoryPosisi]?.length);
    if (activeHasData) return;
    const firstWithData = posisiList.find((pos) => Boolean(posisiHistoryMap?.[pos]?.length));
    setSelectedHistoryPosisi(firstWithData || posisiList[0] || '');
  }, [showPosisiHistoryModal, posisiHistoryMap, posisiList, selectedHistoryPosisi]);

  const buildLampiranUrl = (lampiranPath) => {
    if (!lampiranPath) return '#';
    if (String(lampiranPath).startsWith('http')) return lampiranPath;
    return `${backendPort}${lampiranPath}`;
  };
  const getBeritaAcaraKey = (row) => String(Number(row?.id_ban || 0) || '');
  const getBeritaAcaraAttachments = (row) => {
    const key = getBeritaAcaraKey(row);
    return key ? (beritaAcaraByBanId[key] || []) : [];
  };
  const setBeritaAcaraAttachmentsForRow = (row, updater) => {
    const key = getBeritaAcaraKey(row);
    if (!key) return;
    setBeritaAcaraByBanId((prev) => {
      const current = Array.isArray(prev?.[key]) ? prev[key] : [];
      const next = typeof updater === 'function' ? updater(current) : updater;
      return { ...(prev || {}), [key]: Array.isArray(next) ? next : [] };
    });
  };
  const collectInvalidCaptionIndexesForList = (list = []) => (
    (Array.isArray(list) ? list : [])
      .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  const validateStatusLampiranForRow = (row, nextStatus) => {
    const key = getBeritaAcaraKey(row);
    const list = key ? (beritaAcaraByBanId[key] || []) : [];
    const invalidCaptions = collectInvalidCaptionIndexesForList(list);
    const isAfkir = normalizeStatusText(nextStatus) === 'AFKIR';
    const missingRequiredUpload = isAfkir && list.length === 0;
    return {
      key,
      isAfkir,
      list,
      invalidCaptions,
      missingRequiredUpload,
      invalid: missingRequiredUpload || invalidCaptions.length > 0,
    };
  };
  const clearInvalidBeritaAcaraForKey = (key) => {
    if (!key) return;
    setInvalidBeritaAcaraCaptionIndexesByBanId((prev) => {
      if (!prev?.[key]) return prev;
      const next = { ...(prev || {}) };
      delete next[key];
      return next;
    });
  };

  const close = ()=>{
    setShowDetail(false);
    setShowMaster(true);
  }; 
  const parseDropSlot = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return null;
    const [owner, pos] = raw.split(':');
    const o = String(owner || '').trim();
    const p = String(pos || '').trim();
    if (!o || !p) return null;
    return { owner: o, pos: p };
  };
  const parseDropZone = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return null;
    const [owner, zone = 'formasi'] = raw.split(':');
    const o = String(owner || '').trim();
    const z = String(zone || '').trim() || 'formasi';
    if (!o) return null;
    return { owner: o, zone: z };
  };
  const resolveBanSeri = (idBan) => {
    const id = Number(idBan || 0);
    if (!id) return '';
    return String(banMetaById?.[id]?.seri_ban || '').trim();
  };
  const changeRowByBanId = useMemo(() => {
    const out = {};
    (riwayatPerubahanRows || []).forEach((row) => {
      const id = Number(row?.id_ban || 0);
      if (!id) return;
      out[id] = row;
    });
    return out;
  }, [riwayatPerubahanRows]);
  const formatKmForUi = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return '-';
    return num.toLocaleString('id-ID');
  };
  const buildBanTooltipData = (idBan) => {
    const id = Number(idBan || 0);
    if (!id) return null;
    const meta = banMetaById?.[id] || {};
    const change = changeRowByBanId?.[id] || {};
    const seri = String(change?.seri_ban || meta?.seri_ban || resolveBanSeri(id) || `ID ${id}`).trim();
    const status = String(meta?.status || '-').trim() || '-';
    const km = formatKmForUi(
      meta?.km_tempuh
      ?? meta?.kmtotal
      ?? meta?.odo
      ?? meta?.km
      ?? 0
    );
    const td = String(meta?.td || meta?.td_terakhir || '-').trim() || '-';
    return { id_ban: id, seri, status, km, td };
  };
  const hideBanTooltip = () => {
    setHoverBanTooltip((prev) => ({ ...prev, visible: false }));
  };
  const showBanTooltip = ({ owner = '', pos = '', id_ban = 0, x = 0, y = 0 } = {}) => {
    if (dragMonitor?.active || gudangDrag?.active) return;
    const id = Number(id_ban || 0);
    if (!id) return;
    setHoverBanTooltip({
      visible: true,
      x: Number(x || 0),
      y: Number(y || 0),
      owner: String(owner || '').trim(),
      pos: String(pos || '').trim(),
      id_ban: id,
    });
  };
  const hoverBanData = useMemo(
    () => buildBanTooltipData(hoverBanTooltip?.id_ban),
    [hoverBanTooltip?.id_ban, banMetaById, changeRowByBanId]
  );
  const resolvePlaceValue = (owner, posRaw) => {
    const safeOwner = String(owner || '').trim();
    const pos = String(posRaw || '').trim();
    if (!safeOwner) return '-';
    if (safeOwner === 'gudang') return `gudang#${String(selectedCabang || '').trim() || '-'}`;
    const mtId = safeOwner === 'mt2' ? idMt2 : idMt1;
    return `${String(mtId || safeOwner).trim()}#${pos}`;
  };
  const formatPlaceForUi = (placeRaw) => {
    const place = String(placeRaw || '').trim();
    if (!place) return '-';
    if (place.toLowerCase().startsWith('gudang#')) return 'gudang';
    const [mtId = '', posisi = ''] = place.split('#');
    const mt = String(mtId || '').trim();
    const pos = String(posisi || '').trim();
    const mtLabel = String(resolveNopolByIdMt(mt) || mt).trim() || mt;
    if (!pos) return mtLabel || '-';
    return `${mtLabel}:${pos}`;
  };
  const renderPlaceCell = (placeRaw) => {
    const formatted = String(formatPlaceForUi(placeRaw) || '-').trim() || '-';
    const parts = formatted.split(':');
    const line1 = String(parts[0] || '-').trim() || '-';
    const line2 = String(parts.slice(1).join(':') || '').trim();
    if (!line2) return line1;
    return (
      <div style={{ lineHeight: 1.15 }}>
        <div>{line1}</div>
        <div className="text-muted">{line2}</div>
      </div>
    );
  };
  const buildCurrentPlaceMap = (mapMt1, mapMt2, gudangRows) => {
    const out = {};
    Object.entries(mapMt1 || {}).forEach(([pos, idBan]) => {
      const id = Number(idBan || 0);
      if (!id) return;
      out[id] = resolvePlaceValue('mt1', pos);
    });
    Object.entries(mapMt2 || {}).forEach(([pos, idBan]) => {
      const id = Number(idBan || 0);
      if (!id) return;
      out[id] = resolvePlaceValue('mt2', pos);
    });
    (gudangRows || []).forEach((row) => {
      const id = Number(row?.id_ban || 0);
      if (!id) return;
      out[id] = resolvePlaceValue('gudang', 'gudang');
    });
    return out;
  };
  const buildInitialPlaceSnapshot = (mapMt1, mapMt2, gudangRows) => {
    const currentMap = buildCurrentPlaceMap(mapMt1, mapMt2, gudangRows);
    const out = {};
    Object.entries(currentMap || {}).forEach(([idBan, place]) => {
      out[String(idBan)] = String(place || '').trim();
    });
    return out;
  };
  const saveBaselineState = (mapMt1, mapMt2, gudangRows, gudangIds) => {
    const safeMap1 = { ...(mapMt1 || {}) };
    const safeMap2 = { ...(mapMt2 || {}) };
    const safeGudangRows = [...(gudangRows || [])].map((row) => ({ ...(row || {}) }));
    const safeGudangIds = [...(gudangIds || [])]
      .map((id) => Number(id || 0))
      .filter((id) => id > 0);
    setBaselineState({
      mapMt1: safeMap1,
      mapMt2: safeMap2,
      gudangRows: safeGudangRows,
      gudangIds: safeGudangIds,
      initialPlace: buildInitialPlaceSnapshot(safeMap1, safeMap2, safeGudangRows),
    });
  };
  const classifyEventByPlace = (awalRaw, akhirRaw) => {
    const awal = String(awalRaw || '').trim();
    const akhir = String(akhirRaw || '').trim();
    const awalGudang = awal.toLowerCase().startsWith('gudang#');
    const akhirGudang = akhir.toLowerCase().startsWith('gudang#');
    if (!awalGudang && akhirGudang) return 'Lepas';
    if (awalGudang && !akhirGudang) return 'Pasang';
    if (!awalGudang && !akhirGudang) {
      const mtAwal = awal.split('#')[0] || '';
      const mtAkhir = akhir.split('#')[0] || '';
      if (mtAwal && mtAkhir && mtAwal === mtAkhir) return 'Rotasi';
      return 'Rotasi2';
    }
    return '-';
  };
  const normalizeStatusText = (value) => String(value || '').trim().toUpperCase();
  const parseTierStatusWithSuffix = (value, prefix) => {
    const raw = normalizeStatusText(value);
    const m = raw.match(new RegExp(`^${prefix}-(\\d+)(.*)$`));
    return {
      level: Number(m?.[1] || 0) || 0,
      suffix: String(m?.[2] || '').trim(),
    };
  };
  const getStatusChangeOptions = (currentStatusRaw) => {
    const current = normalizeStatusText(currentStatusRaw);
    const currentAsIs = String(currentStatusRaw || '').trim();
    const mergeUnique = (arr = []) => {
      const out = [];
      const seen = new Set();
      arr.forEach((item) => {
        const val = String(item || '').trim();
        if (!val) return;
        const key = val.toUpperCase();
        if (seen.has(key)) return;
        seen.add(key);
        out.push(val);
      });
      return out;
    };
    if (current === 'NT') return mergeUnique(['NT', 'UT', 'Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    if (current === 'UT') return mergeUnique(['UT', 'Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    if (current.startsWith('VT-')) {
      const { level, suffix } = parseTierStatusWithSuffix(current, 'VT');
      const lvl = Math.max(1, level);
      return mergeUnique([`VT-${lvl}${suffix}`, `UV-${lvl}${suffix}`, 'Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    }
    if (current.startsWith('UV-')) {
      const { level, suffix } = parseTierStatusWithSuffix(current, 'UV');
      const lvl = Math.max(1, level);
      return mergeUnique([`UV-${lvl}${suffix}`, 'Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    }
    if (current === 'CASING') return mergeUnique(['Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    if (current === 'AFKIR') return mergeUnique(['Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
    return mergeUnique([currentAsIs || '-', 'Casing', 'Afkir', 'Perlu Repair', 'Perlu OT']);
  };
  const formatStatusButtonLabel = (awalRaw, akhirRaw) => {
    const awal = String(awalRaw || '-').trim() || '-';
    const akhir = String(akhirRaw || awal).trim() || awal;
    if (normalizeStatusText(awal) === normalizeStatusText(akhir)) return awal;
    return `${awal} -> ${akhir}`;
  };
  const parseTdMinValue = (tdRaw) => {
    const text = String(tdRaw || '').trim();
    if (!text) return null;
    const parts = text.match(/\d+/g) || [];
    const nums = parts.map((x) => Number(x)).filter((x) => Number.isFinite(x));
    if (!nums.length) return null;
    return Math.min(...nums);
  };
  const parseTdSpreadValue = (tdRaw) => {
    const text = String(tdRaw || '').trim();
    if (!text) return null;
    const parts = text.match(/\d+/g) || [];
    const nums = parts.map((x) => Number(x)).filter((x) => Number.isFinite(x));
    if (!nums.length) return null;
    return Math.max(...nums) - Math.min(...nums);
  };
  const buildTdPairList = (formasiValue) => {
    const pairs = [];
    const formasiNum = Number(formasiValue || 0);
    if (!Number.isFinite(formasiNum) || formasiNum <= 0) return pairs;
    const mk = (n) => `P-${String(n).padStart(2, '0')}`;
    const add = (a, b) => {
      if (a > formasiNum || b > formasiNum) return;
      pairs.push([mk(a), mk(b)]);
    };
    if (formasiNum === 8) {
      add(5, 6);
      add(7, 8);
      return pairs;
    }
    [3, 7, 11, 15, 19].forEach((base) => {
      if (formasiNum === 16 && base >= 11) return;
      add(base, base + 1);
      add(base + 2, base + 3);
    });
    return pairs;
  };
  const calcTdWarningPosisi = (banMap = {}, formasiValue = 0) => {
    const warn = new Set();
    const pairs = buildTdPairList(formasiValue);
    pairs.forEach(([p1, p2]) => {
      const id1 = Number(banMap?.[p1] || 0);
      const id2 = Number(banMap?.[p2] || 0);
      if (!id1 || !id2) return;
      const td1 = parseTdMinValue(banMetaById?.[id1]?.td);
      const td2 = parseTdMinValue(banMetaById?.[id2]?.td);
      if (td1 == null || td2 == null) return;
      if (Math.abs(td1 - td2) >= 3) {
        warn.add(p1);
        warn.add(p2);
      }
    });
    return Array.from(warn);
  };
  const calcUnevenWearPosisi = (banMap = {}) => {
    const warn = new Set();
    Object.entries(banMap || {}).forEach(([pos, idBan]) => {
      const id = Number(idBan || 0);
      if (!id) return;
      const spread = parseTdSpreadValue(banMetaById?.[id]?.td);
      if (spread == null) return;
      if (spread >= 3) warn.add(String(pos || '').trim());
    });
    return Array.from(warn);
  };
  const replaceGudangBanById = (rows, oldId, newRow) => (rows || []).map((item) => (
    Number(item?.id_ban || 0) === Number(oldId || 0) ? { ...(item || {}), ...(newRow || {}) } : item
  ));
  const buildGudangBanRow = (idBan, fallbackLabel = '') => {
    const id = Number(idBan || 0);
    if (!id) return null;
    const seri = resolveBanSeri(id) || String(fallbackLabel || `ID ${id}`).trim();
    return {
      id_ban: id,
      seri_ban: seri,
      status: String(banMetaById?.[id]?.status || '').trim(),
    };
  };
  const parsePlaceOwnerPos = (placeRaw) => {
    const place = String(placeRaw || '').trim();
    if (!place) return null;
    if (place.toLowerCase().startsWith('gudang#')) return { owner: 'gudang', pos: 'gudang' };
    const [mtId = '', pos = ''] = place.split('#');
    const mt = String(mtId || '').trim();
    const p = String(pos || '').trim();
    if (!mt || !p) return null;
    if (mt === String(idMt1 || '').trim()) return { owner: 'mt1', pos: p };
    if (mt === String(idMt2 || '').trim()) return { owner: 'mt2', pos: p };
    return null;
  };
  const changedPosisiMt = useMemo(() => {
    const mt1 = new Set();
    const mt2 = new Set();
    (riwayatPerubahanRows || []).forEach((row) => {
      const awal = parsePlaceOwnerPos(row?.posisi_awal);
      const akhir = parsePlaceOwnerPos(row?.posisi_akhir);
      if (awal?.owner === 'mt1' && awal?.pos) mt1.add(awal.pos);
      if (awal?.owner === 'mt2' && awal?.pos) mt2.add(awal.pos);
      if (akhir?.owner === 'mt1' && akhir?.pos) mt1.add(akhir.pos);
      if (akhir?.owner === 'mt2' && akhir?.pos) mt2.add(akhir.pos);
    });
    return {
      mt1: Array.from(mt1),
      mt2: Array.from(mt2),
    };
  }, [riwayatPerubahanRows, idMt1, idMt2]);
  const changedBanIdSet = useMemo(() => {
    const set = new Set();
    (riwayatPerubahanRows || []).forEach((row) => {
      const id = Number(row?.id_ban || 0);
      if (id > 0) set.add(id);
    });
    return set;
  }, [riwayatPerubahanRows]);
  const changedBanSeriSet = useMemo(() => {
    const set = new Set();
    (riwayatPerubahanRows || []).forEach((row) => {
      const seri = String(row?.seri_ban || '').trim().toUpperCase();
      if (seri) set.add(seri);
    });
    return set;
  }, [riwayatPerubahanRows]);
  const tdWarningPosisiMt1 = useMemo(
    () => calcTdWarningPosisi(daftarBanMapMt1, formasiMt1),
    [daftarBanMapMt1, formasiMt1, banMetaById]
  );
  const tdWarningPosisiMt2 = useMemo(
    () => calcTdWarningPosisi(isDualMt ? daftarBanMapMt2 : daftarBanMapMt1, isDualMt ? formasiMt2 : formasiMt1),
    [daftarBanMapMt2, daftarBanMapMt1, formasiMt2, formasiMt1, isDualMt, banMetaById]
  );
  const unevenWearPosisiMt1 = useMemo(
    () => calcUnevenWearPosisi(daftarBanMapMt1),
    [daftarBanMapMt1, banMetaById]
  );
  const unevenWearPosisiMt2 = useMemo(
    () => calcUnevenWearPosisi(isDualMt ? daftarBanMapMt2 : daftarBanMapMt1),
    [daftarBanMapMt2, daftarBanMapMt1, isDualMt, banMetaById]
  );
  const hoverIndikasiText = useMemo(() => {
    const idBan = Number(hoverBanTooltip?.id_ban || 0);
    if (!idBan) return '-';
    const owner = String(hoverBanTooltip?.owner || '').trim();
    const pos = String(hoverBanTooltip?.pos || '').trim();
    const indications = [];
    const spread = parseTdSpreadValue(banMetaById?.[idBan]?.td);
    if (spread != null && spread >= 3) indications.push('aus tidak merata');
    if (owner === 'mt1' && pos && tdWarningPosisiMt1.includes(pos)) indications.push('td tidak seimbang');
    if (owner === 'mt2' && pos && tdWarningPosisiMt2.includes(pos)) indications.push('td tidak seimbang');
    if (!indications.length) return '-';
    return Array.from(new Set(indications)).join(', ');
  }, [
    hoverBanTooltip?.id_ban,
    hoverBanTooltip?.owner,
    hoverBanTooltip?.pos,
    banMetaById,
    tdWarningPosisiMt1,
    tdWarningPosisiMt2,
  ]);
  const parseSubmitPlaceOwner = (placeRaw) => {
    const place = String(placeRaw || '').trim();
    if (!place) return { owner: 'unknown', mtId: '', pos: '', place: '' };
    if (place.toLowerCase().startsWith('gudang#')) {
      return { owner: 'gudang', mtId: '', pos: 'gudang', place };
    }
    const [mtId = '', pos = ''] = place.split('#');
    const mt = String(mtId || '').trim();
    const p = String(pos || '').trim();
    if (!mt || !p) return { owner: 'unknown', mtId: mt, pos: p, place };
    if (mt === String(idMt1 || '').trim()) return { owner: 'mt1', mtId: mt, pos: p, place };
    if (mt === String(idMt2 || '').trim()) return { owner: 'mt2', mtId: mt, pos: p, place };
    return { owner: 'other_mt', mtId: mt, pos: p, place };
  };
  const isRowLepasToGudang = (row) => {
    const eventText = String(row?.event || '').trim().toLowerCase();
    if (eventText === 'lepas') return true;
    const akhirRaw = String(row?.posisi_akhir || '').trim().toLowerCase();
    if (akhirRaw === 'gudang' || akhirRaw.startsWith('gudang#')) return true;
    const awal = parseSubmitPlaceOwner(row?.posisi_awal);
    const akhir = parseSubmitPlaceOwner(row?.posisi_akhir);
    return awal.owner !== 'gudang' && akhir.owner === 'gudang';
  };
  useEffect(() => {
    let ignore = false;
    const lepasIds = Array.from(new Set(
      (Array.isArray(riwayatPerubahanRows) ? riwayatPerubahanRows : [])
        .filter((row) => isRowLepasToGudang(row))
        .map((row) => Number(row?.id_ban || 0))
        .filter((id) => id > 0)
    ));
    const needLoad = lepasIds.filter((id) => kmtOtfByBanId[String(id)] == null);
    if (!needLoad.length) return undefined;
    (async () => {
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_ROTASI_KMT_OTF, reason: 'Refresh kmt otf lepas' });
        for (const idBan of needLoad) {
          const { data } = await api.post(`${backendPort}/api/main/load_kmt_otf_saat_lepas`, { id_ban: idBan }, {
            requestGroup: REQ_GROUP_ROTASI_KMT_OTF,
            timeout: 30000,
          });
          if (ignore) return;
          const rows = Array.isArray(data?.rows) ? data.rows : [];
          const first = rows.find((item) => Number(item?.id_ban || 0) === Number(idBan));
          const raw = first?.kmt_otf;
          const num = Number(raw);
          setKmtOtfByBanId((prev) => ({
            ...(prev || {}),
            [String(idBan)]: Number.isFinite(num) ? Math.trunc(num) : 0,
          }));
        }
      } catch (err) {
        if (!api.isCanceledError?.(err)) console.error(err);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [riwayatPerubahanRows, kmtOtfByBanId]);
  useEffect(() => {
    if (!Object.keys(kmtOtfByBanId || {}).length) return;
    setRiwayatPerubahanRows((prev) => (Array.isArray(prev) ? prev : []).map((row) => {
      if (!isRowLepasToGudang(row)) return row;
      const id = Number(row?.id_ban || 0);
      if (!id) return row;
      const loaded = kmtOtfByBanId[String(id)];
      if (loaded == null || loaded === '') return row;
      if (Number(row?.kmt_otf) === Number(loaded)) return row;
      return { ...row, kmt_otf: Number(loaded) };
    }));
  }, [kmtOtfByBanId]);
  const validPerubahanRows = useMemo(
    () => (Array.isArray(riwayatPerubahanRows) ? riwayatPerubahanRows : [])
      .map((row) => {
        const idBan = Number(row?.id_ban || 0);
        const posisiAwal = String(row?.posisi_awal || '').trim();
        const posisiAkhir = String(row?.posisi_akhir || '').trim();
        const statusAwal = String(row?.status_awal || '-').trim() || '-';
        const statusAkhir = String(row?.status_akhir || statusAwal).trim() || statusAwal;
        const catatan = String(row?.catatan || '').trim();
        const awal = parseSubmitPlaceOwner(posisiAwal);
        const akhir = parseSubmitPlaceOwner(posisiAkhir);
        const isLepasToGudang = awal.owner !== 'gudang' && akhir.owner === 'gudang';
        if (!idBan || !posisiAwal || !posisiAkhir) return null;
        if (posisiAwal === posisiAkhir) return null;
        return {
          id_ban: idBan,
          seri_ban: String(row?.seri_ban || '').trim(),
          posisi_awal: posisiAwal,
          posisi_akhir: posisiAkhir,
          event: String(row?.event || '').trim(),
          status_awal: statusAwal,
          status_akhir: statusAkhir,
          catatan,
          ban_defect: isLepasToGudang
            ? (String(row?.ban_defect || '').trim())
            : '',
          indikasi: isLepasToGudang
            ? (String(row?.indikasi || '').trim())
            : '',
          tindak_lanjut: isLepasToGudang
            ? (String(row?.tindak_lanjut || '').trim())
            : '',
          sopir: isLepasToGudang
            ? (String(row?.sopir || '').trim())
            : '',
          kmt_otf: isLepasToGudang
            ? (() => {
                const v = row?.kmt_otf;
                if (v === '' || v == null) return '';
                const n = Number(v);
                return Number.isFinite(n) ? Math.trunc(n) : '';
              })()
            : '',
        };
      })
      .filter(Boolean),
    [riwayatPerubahanRows]
  );
  const validRepairRows = useMemo(() => (Array.isArray(repairRows) ? repairRows : [])
    .map((row) => ({
      id_ban: Number(row?.id_ban || 0),
      id_mt: String(row?.id_mt || '').trim(),
      posisi: String(row?.posisi || '').trim(),
      seri_ban: String(row?.seri_ban || '').trim(),
      status_lama: String(row?.status_lama || '').trim(),
      status_baru: String(row?.status_baru || '').trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      jenis_tambal: String(row?.jenis_tambal || '').trim(),
      bahan_tambal: String(row?.bahan_tambal || '').trim(),
      catatan: String(row?.catatan || ''),
      posisi_awal_repair: String(row?.posisi_awal_repair || '').trim(),
      repair_blocked_reason: String(row?.repair_blocked_reason || '').trim(),
    }))
    .filter((row) => row.id_ban > 0 && row.id_mt && row.posisi), [repairRows]);
  const repairRowsValid = useMemo(() => validRepairRows.every((row) => (
    Number.isFinite(row.qty_tambal) && row.qty_tambal >= 0 && row.qty_tambal <= 4
    && row.jenis_tambal && row.status_baru && !row.repair_blocked_reason
  )), [validRepairRows]);
  const repairRowsShapeValid = repairRows.length === validRepairRows.length;
  const addRepairRow = (candidate) => {
    const idBan = Number(candidate?.id_ban || 0);
    if (!idBan) return;
    setRepairRows((prev) => {
      if ((prev || []).some((row) => Number(row?.id_ban || 0) === idBan)) return prev;
      const movementRow = riwayatPerubahanRows.find((row) => Number(row?.id_ban || 0) === idBan);
      return [...(prev || []), {
        ...candidate,
        qty_tambal: 0,
        jenis_tambal: '',
        bahan_tambal: '',
        catatan: '',
        status_baru: normalizeStatusText(movementRow?.status_akhir) === 'AFKIR'
          ? String(movementRow?.status_akhir || '').trim()
          : (normalizeStatusText(candidate?.status_lama) === 'AFKIR' ? '' : String(movementRow?.status_akhir || candidate?.status_lama || '').trim()),
        posisi_awal_repair: String(candidate?.posisi_awal_repair || `${candidate?.id_mt || ''}#${candidate?.posisi || ''}`).trim(),
        repair_blocked_reason: '',
      }];
    });
  };
  const updateRepairRow = (idBan, patch) => setRepairRows((prev) => (prev || []).map((row) => (
    Number(row?.id_ban || 0) === Number(idBan) ? { ...row, ...patch } : row
  )));
  const updateMirroredBanStatus = (idBan, statusFinal) => {
    const idBanNum = Number(idBan || 0);
    const nextStatus = String(statusFinal || '').trim();
    if (!idBanNum || !nextStatus) return;
    setRiwayatPerubahanRows((prev) => (prev || []).map((row) => (
      Number(row?.id_ban || 0) === idBanNum ? { ...row, status_akhir: nextStatus } : row
    )));
    setRepairRows((prev) => (prev || []).map((row) => (
      Number(row?.id_ban || 0) === idBanNum ? { ...row, status_baru: nextStatus } : row
    )));
  };
  const removeRepairRow = (idBan) => {
    const key = String(Number(idBan || 0));
    setRepairRows((prev) => (prev || []).filter((row) => Number(row?.id_ban || 0) !== Number(idBan)));
    setRepairAttachmentsByBanId((prev) => {
      if (!prev?.[key]) return prev;
      const next = { ...(prev || {}) };
      delete next[key];
      return next;
    });
  };
  const activeRepairDetailRow = useMemo(() => repairRows.find((row) => Number(row?.id_ban || 0) === activeRepairDetailBanId) || null, [repairRows, activeRepairDetailBanId]);
  const activeRepairAttachments = useMemo(
    () => (repairAttachmentsByBanId?.[String(activeRepairDetailBanId)] || []),
    [repairAttachmentsByBanId, activeRepairDetailBanId]
  );
  const openRepairDetailEditor = (row) => {
    const idBan = Number(row?.id_ban || 0);
    if (!idBan) return;
    setActiveRepairDetailBanId(idBan);
    setOpenRepairDetailModal(true);
  };
  const handleRepairBanImageClick = (owner, posisi) => {
    const map = owner === 'mt2' ? daftarBanMapMt2 : daftarBanMapMt1;
    const posisiFinal = String(posisi || '').trim();
    const idBan = Number(map?.[posisiFinal] || 0);
    if (!idBan) {
      showNotif('info', `Posisi ${posisiFinal || '-'} belum berisi ban.`);
      return;
    }
    if (repairRows.some((row) => Number(row?.id_ban || 0) === idBan)) {
      showNotif('info', `Ban ${resolveBanSeri(idBan) || idBan} sudah dipilih untuk repair.`);
      return;
    }
    const rotasiBan = riwayatPerubahanRows.find((row) => Number(row?.id_ban || 0) === idBan);
    const candidate = {
      id_ban: idBan,
      id_mt: owner === 'mt2' ? String(idMt2 || '').trim() : String(idMt1 || '').trim(),
      posisi: posisiFinal,
      seri_ban: String(resolveBanSeri(idBan) || banMetaById?.[idBan]?.seri_ban || `ID ${idBan}`).trim(),
      status_lama: String(banMetaById?.[idBan]?.status || '').trim(),
      posisi_awal_repair: String(rotasiBan?.posisi_awal || '').trim(),
    };
    addRepairRow(candidate);
    showNotif('success', `Ban ${candidate.seri_ban} posisi ${posisiFinal} ditambahkan ke Repair.`);
  };
  const syncRepairRowsToFinalPlaces = (nextMapMt1, nextMapMt2, nextGudangRows) => {
    const nextPlaceMap = buildCurrentPlaceMap(nextMapMt1, nextMapMt2, nextGudangRows);
    setRepairRows((prev) => (prev || []).map((row) => {
      const idBan = Number(row?.id_ban || 0);
      const finalPlace = String(nextPlaceMap?.[idBan] || '').trim();
      const posisiAwalRepair = String(row?.posisi_awal_repair || `${row?.id_mt || ''}#${row?.posisi || ''}`).trim();
      if (finalPlace.toLowerCase().startsWith('gudang#')) {
        return {
          ...row,
          posisi_awal_repair: posisiAwalRepair,
          repair_blocked_reason: 'Ban berakhir di Gudang. Hapus dari Repair MT atau pindahkan kembali ke posisi MT.',
        };
      }
      const [idMtFinal = '', posisiFinal = ''] = finalPlace.split('#');
      if (!idMtFinal || !posisiFinal) return row;
      return {
        ...row,
        id_mt: idMtFinal,
        posisi: posisiFinal,
        posisi_awal_repair: posisiAwalRepair,
        repair_blocked_reason: '',
      };
    }));
  };
  const tipeEventSubmit = useMemo(() => {
    if (!validPerubahanRows.length) return '';
    const hasGudang = validPerubahanRows.some((row) => {
      const awal = parseSubmitPlaceOwner(row?.posisi_awal);
      const akhir = parseSubmitPlaceOwner(row?.posisi_akhir);
      return awal.owner === 'gudang' || akhir.owner === 'gudang';
    });
    const hasRotasi2 = validPerubahanRows.some((row) => {
      const awal = parseSubmitPlaceOwner(row?.posisi_awal);
      const akhir = parseSubmitPlaceOwner(row?.posisi_akhir);
      return (
        (awal.owner === 'mt1' && akhir.owner === 'mt2')
        || (awal.owner === 'mt2' && akhir.owner === 'mt1')
      );
    });
    const hasRotasi = validPerubahanRows.some((row) => {
      const awal = parseSubmitPlaceOwner(row?.posisi_awal);
      const akhir = parseSubmitPlaceOwner(row?.posisi_akhir);
      return (
        (awal.owner === 'mt1' && akhir.owner === 'mt1')
        || (awal.owner === 'mt2' && akhir.owner === 'mt2')
      );
    });
    if (hasRotasi2 && hasGudang) return 'rotasi2+ganti_ban';
    if (hasRotasi2) return 'rotasi2';
    if (hasRotasi && hasGudang) return 'rotasi+ganti_ban';
    if (hasRotasi) return 'rotasi';
    if (hasGudang) return 'ganti_ban';
    return '';
  }, [validPerubahanRows]);
  const mtTerlibatSubmit = useMemo(() => {
    const involved = {
      mt1: false,
      mt2: false,
    };
    validPerubahanRows.forEach((row) => {
      const awal = parseSubmitPlaceOwner(row?.posisi_awal);
      const akhir = parseSubmitPlaceOwner(row?.posisi_akhir);
      if (awal.owner === 'mt1' || akhir.owner === 'mt1') involved.mt1 = true;
      if (awal.owner === 'mt2' || akhir.owner === 'mt2') involved.mt2 = true;
    });
    return involved;
  }, [validPerubahanRows]);
  const hasRotasiSubmit = Boolean(validPerubahanRows.length > 0 && tipeEventSubmit);
  const hasRepairSubmit = validRepairRows.length > 0;
  const blockedRepairRow = useMemo(() => repairRows.find((row) => String(row?.repair_blocked_reason || '').trim()) || null, [repairRows]);
  const bisaSubmitDasar = useMemo(
    () => Boolean((hasRotasiSubmit || hasRepairSubmit) && repairRowsShapeValid && repairRowsValid),
    [hasRotasiSubmit, hasRepairSubmit, repairRowsShapeValid, repairRowsValid]
  );
  const storingLastCheckTargets = useMemo(() => {
    if (!isStoringRotasiContext) return [];
    const byMt = new Map();
    const parseRelevantSource = (placeRaw) => {
      const place = String(placeRaw || '').trim();
      if (!place || place.toLowerCase().startsWith('gudang#')) return null;
      const [mtIdRaw = '', posisiRaw = ''] = place.split('#');
      const mtId = String(mtIdRaw || '').trim();
      const posisi = String(posisiRaw || '').trim();
      if (!mtId || !posisi || (mtId !== idMt1 && mtId !== idMt2)) return null;
      return { mtId, posisi };
    };
    const ensureMt = (idMtRaw) => {
      const idMt = String(idMtRaw || '').trim();
      if (!idMt) return null;
      if (!byMt.has(idMt)) byMt.set(idMt, { idMt, tdBans: new Map() });
      return byMt.get(idMt);
    };
    const addTdBan = (idMtRaw, posisiRaw, idBanRaw) => {
      const target = ensureMt(idMtRaw);
      const idBan = Number(idBanRaw || 0);
      const posisi = String(posisiRaw || '').trim();
      if (!target || !idBan || !posisi) return;
      target.tdBans.set(idBan, { idBan, posisi });
    };

    validPerubahanRows.forEach((row) => {
      const awal = parseRelevantSource(row?.posisi_awal);
      const akhir = parseRelevantSource(row?.posisi_akhir);
      if (awal) addTdBan(awal.mtId, awal.posisi, row.id_ban);
      if (awal) ensureMt(awal.mtId);
      if (akhir) ensureMt(akhir.mtId);
    });
    validRepairRows.forEach((row) => {
      const sumber = parseRelevantSource(row?.posisi_awal_repair || `${row?.id_mt || ''}#${row?.posisi || ''}`);
      if (sumber) {
        addTdBan(sumber.mtId, sumber.posisi, row.id_ban);
        ensureMt(sumber.mtId);
      }
      ensureMt(row.id_mt);
    });
    return Array.from(byMt.values()).map((target) => ({
      idMt: target.idMt,
      tdBans: Array.from(target.tdBans.values()).sort((a, b) => a.posisi.localeCompare(b.posisi)),
    }));
  }, [isStoringRotasiContext, validPerubahanRows, validRepairRows, idMt1, idMt2]);
  useEffect(() => {
    let ignore = false;
    if (!isStoringRotasiContext || !storingLastCheckTargets.length) {
      setStoringLastCheckLoading(false);
      setStoringLastCheckByMt({});
      return undefined;
    }
    setStoringLastCheckLoading(true);
    api.cancelPendingRequests({
      group: REQ_GROUP_ROTASI_STORING_LAST_CHECK,
      reason: 'Refresh last check storing rotasi',
    });
    Promise.all(storingLastCheckTargets.map(async ({ idMt, tdBans }) => {
      const { data: raw } = await api.get(`${backendPort}/api/main/load_last_check/${idMt}`, {
        requestGroup: REQ_GROUP_ROTASI_STORING_LAST_CHECK,
        timeout: 120000,
      });
      const data = (raw && typeof raw === 'object') ? raw : {};
      const serverDate = String(data?.odo_gate?.tanggal_server || formatYYYYMMDD(new Date())).trim();
      const odoDate = formatYYYYMMDD(data?.mt_odo?.tanggal || '');
      const kmtdByBanId = new Map((Array.isArray(data?.ban_last_kmtd) ? data.ban_last_kmtd : [])
        .map((row) => [Number(row?.id_ban || 0), row]));
      return [idMt, {
        serverDate,
        odoToday: Boolean(odoDate && odoDate === serverDate),
        odoDate,
        odoValue: Number(data?.mt_odo?.odo || 0),
        tdBans: tdBans.map((ban) => {
          const kmtd = kmtdByBanId.get(ban.idBan) || {};
          const tdDate = formatYYYYMMDD(kmtd?.tgltd || kmtd?.tgl || '');
          return { ...ban, tdDate, tdToday: Boolean(tdDate && tdDate === serverDate) };
        }),
      }];
    })).then((entries) => {
      if (!ignore) setStoringLastCheckByMt(Object.fromEntries(entries));
    }).catch((err) => {
      if (!api.isCanceledError?.(err)) console.error(err);
      if (!ignore) setStoringLastCheckByMt({});
    }).finally(() => {
      if (!ignore) setStoringLastCheckLoading(false);
    });
    return () => { ignore = true; };
  }, [isStoringRotasiContext, storingLastCheckTargets, storingLastCheckRefreshTick]);
  const storingLastCheckReady = useMemo(() => {
    if (!isStoringRotasiContext) return true;
    if (storingLastCheckLoading || !storingLastCheckTargets.length) return false;
    return storingLastCheckTargets.every(({ idMt, tdBans }) => {
      const check = storingLastCheckByMt?.[idMt];
      return Boolean(check?.odoToday) && tdBans.every((ban) => (
        check?.tdBans?.some((item) => item.idBan === ban.idBan && item.tdToday)
      ));
    });
  }, [isStoringRotasiContext, storingLastCheckLoading, storingLastCheckTargets, storingLastCheckByMt]);
  const bisaSubmit = Boolean(bisaSubmitDasar && storingLastCheckReady);
  const submitLabel = isStoringRotasiContext
    ? (hasRotasiSubmit && hasRepairSubmit
      ? 'Simpan Storing Rotasi dan Repair'
      : (hasRepairSubmit ? 'Simpan Storing Repair' : 'Simpan Storing Rotasi'))
    : (hasRotasiSubmit && hasRepairSubmit
      ? 'Simpan Rotasi dan Repair'
      : (hasRepairSubmit ? 'Simpan Repair' : 'Simpan Rotasi'));
  useEffect(() => {
    if (baselineState) return;
    if ((riwayatPerubahanRows || []).length > 0) return;
    const hasAnyData = (
      Object.keys(daftarBanMapMt1 || {}).length > 0
      || Object.keys(daftarBanMapMt2 || {}).length > 0
      || (selectedGudangBanRows || []).length > 0
    );
    if (!hasAnyData) return;
    saveBaselineState(daftarBanMapMt1, daftarBanMapMt2, selectedGudangBanRows, selectedGudangBanIds);
  }, [
    baselineState,
    riwayatPerubahanRows,
    daftarBanMapMt1,
    daftarBanMapMt2,
    selectedGudangBanRows,
    selectedGudangBanIds,
  ]);
  useEffect(() => {
    const currentMap = buildCurrentPlaceMap(daftarBanMapMt1, daftarBanMapMt2, selectedGudangBanRows);
    setInitialPlaceByBanId((prev) => {
      const next = { ...(prev || {}) };
      let changed = false;
      Object.entries(currentMap).forEach(([idBan, place]) => {
        const key = String(idBan);
        if (next[key]) return;
        next[key] = String(place || '').trim();
        changed = true;
      });
      return changed ? next : prev;
    });
  }, [daftarBanMapMt1, daftarBanMapMt2, selectedGudangBanRows]);
  const handleFormasiDragDrop = ({ source, target }) => {
    const sourceOwner = String(source?.owner || '').trim();
    const sourcePos = String(source?.pos || '').trim();
    const sourceIdBan = Number(source?.id_ban || 0);
    const sourceLabel = String(source?.label || '').trim();
    const targetKind = String(target?.kind || '').trim();
    const targetOwner = String(target?.owner || '').trim();
    const targetPos = String(target?.pos || '').trim();
    if (!sourceOwner || !sourcePos) return;
    if (targetKind !== 'slot' || !targetOwner || !targetPos) return;
    if (sourceOwner === targetOwner && sourcePos === targetPos) return;
    const mapSource = sourceOwner === 'mt2' ? { ...(daftarBanMapMt2 || {}) } : { ...(daftarBanMapMt1 || {}) };
    const mapTargetBase = targetOwner === 'mt2' ? { ...(daftarBanMapMt2 || {}) } : { ...(daftarBanMapMt1 || {}) };
    let nextMapMt1 = { ...(daftarBanMapMt1 || {}) };
    let nextMapMt2 = { ...(daftarBanMapMt2 || {}) };
    let nextGudangRows = [...(selectedGudangBanRows || [])];
    let movedIdBan = 0;

    if (sourceOwner === 'gudang') {
      movedIdBan = sourceIdBan;
    } else {
      movedIdBan = Number(mapSource?.[sourcePos] || sourceIdBan || 0);
    }
    if (!movedIdBan) return;

    const targetCurrentId = targetOwner === 'gudang'
      ? Number(targetPos || 0)
      : Number(mapTargetBase?.[targetPos] || 0);
    if (!targetCurrentId) return;

    if (sourceOwner === 'gudang') {
      nextGudangRows = replaceGudangBanById(nextGudangRows, movedIdBan, buildGudangBanRow(targetCurrentId, `ID ${targetCurrentId}`));
    } else if (sourceOwner === 'mt1') {
      delete nextMapMt1[sourcePos];
    } else if (sourceOwner === 'mt2') {
      delete nextMapMt2[sourcePos];
    }

    if (targetOwner === 'gudang') {
      nextGudangRows = replaceGudangBanById(nextGudangRows, targetCurrentId, buildGudangBanRow(movedIdBan, sourceLabel || `ID ${movedIdBan}`));
    } else if (targetOwner === 'mt1') {
      nextMapMt1[targetPos] = movedIdBan;
    } else if (targetOwner === 'mt2') {
      nextMapMt2[targetPos] = movedIdBan;
    }

    if (sourceOwner === 'mt1') nextMapMt1[sourcePos] = targetCurrentId;
    if (sourceOwner === 'mt2') nextMapMt2[sourcePos] = targetCurrentId;

    const sourcePlace = sourceOwner === 'gudang'
      ? resolvePlaceValue('gudang', sourcePos)
      : resolvePlaceValue(sourceOwner, sourcePos);
    const targetPlace = targetOwner === 'gudang'
      ? resolvePlaceValue('gudang', targetPos)
      : resolvePlaceValue(targetOwner, targetPos);

    const nextGudangIds = nextGudangRows.map((x) => Number(x?.id_ban || 0)).filter((x) => x > 0);
    const currentPlacePrev = buildCurrentPlaceMap(daftarBanMapMt1, daftarBanMapMt2, selectedGudangBanRows);
    const currentPlaceNext = buildCurrentPlaceMap(nextMapMt1, nextMapMt2, nextGudangRows);
    const touchedBanIds = [movedIdBan, targetCurrentId].filter((x) => Number(x || 0) > 0);
    const nextInitialPlace = { ...(initialPlaceByBanId || {}) };
    touchedBanIds.forEach((id) => {
      const key = String(id);
      if (nextInitialPlace[key]) return;
      nextInitialPlace[key] = String(currentPlacePrev?.[id] || '').trim()
        || (id === movedIdBan ? sourcePlace : targetPlace);
    });

    setDaftarBanMapMt1(nextMapMt1);
    setDaftarBanMapMt2(nextMapMt2);
    setSelectedGudangBanRows(nextGudangRows);
    setSelectedGudangBanIds(nextGudangIds);
    setInitialPlaceByBanId(nextInitialPlace);
    syncRepairRowsToFinalPlaces(nextMapMt1, nextMapMt2, nextGudangRows);
    setRiwayatPerubahanRows((prev) => {
      const mapPrev = {};
      (prev || []).forEach((row) => {
        const id = Number(row?.id_ban || 0);
        if (!id) return;
        mapPrev[id] = row;
      });
      touchedBanIds.forEach((id) => {
        const key = String(id);
        const existing = mapPrev[id] || null;
        const awal = String(nextInitialPlace?.[key] || currentPlacePrev?.[id] || '').trim()
          || String(currentPlaceNext?.[id] || '').trim()
          || '-';
        const akhir = String(currentPlaceNext?.[id] || '').trim() || awal;
        const posisiAwalFinal = String(existing?.posisi_awal || awal).trim();
        const posisiAkhirFinal = String(akhir || posisiAwalFinal).trim();

        if (posisiAwalFinal && posisiAkhirFinal && posisiAwalFinal === posisiAkhirFinal) {
          delete mapPrev[id];
          return;
        }

        const eventNow = classifyEventByPlace(existing?.posisi_awal || awal, akhir);
        const statusAwal = String(existing?.status_awal || banMetaById?.[id]?.status || '-').trim() || '-';
        const defaultStatusAkhir = eventNow === 'Lepas' ? 'Casing' : statusAwal;
        const mirroredRepairStatus = String(
          repairRows.find((repairRow) => Number(repairRow?.id_ban || 0) === Number(id))?.status_baru || ''
        ).trim();
        const statusAkhir = String(existing?.status_akhir || mirroredRepairStatus || defaultStatusAkhir).trim() || defaultStatusAkhir;
        const ketLepas = eventNow === 'Lepas'
          ? (String(existing?.ban_defect || '').trim())
          : '';
        const indikasi = eventNow === 'Lepas'
          ? (String(existing?.indikasi || '').trim())
          : '';
        const kmtOtf = eventNow === 'Lepas'
          ? (() => {
              const direct = existing?.kmt_otf;
              if (direct !== '' && direct != null && Number.isFinite(Number(direct))) return Math.trunc(Number(direct));
              const fromMap = kmtOtfByBanId[String(id)];
              if (fromMap !== '' && fromMap != null && Number.isFinite(Number(fromMap))) return Math.trunc(Number(fromMap));
              return '';
            })()
          : '';
        mapPrev[id] = {
          id: existing?.id || `ban-${id}`,
          id_ban: id,
          seri_ban: resolveBanSeri(id) || existing?.seri_ban || `ID ${id}`,
          posisi_awal: posisiAwalFinal,
          posisi_akhir: posisiAkhirFinal,
          event: eventNow,
          status_awal: statusAwal,
          status_akhir: statusAkhir,
          catatan: existing?.catatan || '',
          ban_defect: ketLepas,
          indikasi,
          tindak_lanjut: eventNow === 'Lepas'
            ? (String(existing?.tindak_lanjut || '').trim())
            : '',
          sopir: eventNow === 'Lepas'
            ? (String(existing?.sopir || '').trim())
            : '',
          kmt_otf: kmtOtf,
        };
      });
      return Object.values(mapPrev);
    });
  };
  const openStatusEditor = (row) => {
    if (!row) return;
    const statusAwal = String(row?.status_awal || '-').trim() || '-';
    const statusAkhir = String(row?.status_akhir || statusAwal).trim() || statusAwal;
    setStatusBanTargetRow(row);
    setStatusBanDraftNext(statusAkhir);
    setOpenStatusBanModal(true);
  };
  const statusBanOptions = useMemo(
    () => getStatusChangeOptions(statusBanTargetRow?.status_awal || '-'),
    [statusBanTargetRow?.status_awal]
  );
  const getRepairStatusOptions = (row) => {
    const options = getStatusChangeOptions(row?.status_lama || '-').filter(
      (item) => normalizeStatusText(item) !== 'AFKIR'
    );
    const mirroredMovement = riwayatPerubahanRows.find(
      (item) => Number(item?.id_ban || 0) === Number(row?.id_ban || 0)
    );
    const mirroredAfkir = normalizeStatusText(mirroredMovement?.status_akhir) === 'AFKIR'
      && normalizeStatusText(row?.status_baru) === 'AFKIR';
    return mirroredAfkir ? [...options, 'Afkir'] : options;
  };
  const handleSaveStatusBanModal = () => {
    const idRow = String(statusBanTargetRow?.id || '').trim();
    const nextStatus = String(statusBanDraftNext || '').trim();
    if (!idRow || !nextStatus) return;
    const lampiranValidation = validateStatusLampiranForRow(statusBanTargetRow, nextStatus);
    if (lampiranValidation.invalid) {
      if (lampiranValidation.key) {
        setInvalidBeritaAcaraCaptionIndexesByBanId((prev) => ({
          ...(prev || {}),
          [lampiranValidation.key]: lampiranValidation.invalidCaptions.length
            ? lampiranValidation.invalidCaptions
            : [-1],
        }));
      }
      showNotif(
        'error',
        lampiranValidation.missingRequiredUpload
          ? 'Upload BA Analisa wajib diisi minimal 1 dokumen untuk status Afkir.'
          : 'Caption dokumen wajib diisi untuk semua lampiran perubahan status.'
      );
      return;
    }
    clearInvalidBeritaAcaraForKey(lampiranValidation.key);
    updateMirroredBanStatus(statusBanTargetRow?.id_ban, nextStatus);
    setOpenStatusBanModal(false);
  };
  const openKetLepasEditor = (row) => {
    if (!row) return;
    const isLepas = isRowLepasToGudang(row);
    setKetLepasTargetRow(row);
    setKetLepasDraft(isLepas ? (String(row?.ban_defect || '').trim() || '') : '');
    setIndikasiDraft(isLepas ? (String(row?.indikasi || '').trim() || 'Normal') : '');
    setCatatanDraft(String(row?.catatan || '').trim());
    setTindakLanjutDraft(isLepas ? (String(row?.tindak_lanjut || '').trim() || '') : '');
    setNamaSopirDraft(isLepas ? (String(row?.sopir || '').trim() || '') : '');
    setOpenKetLepasModal(true);
  };
  const handleSaveKetLepasModal = () => {
    const idRow = String(ketLepasTargetRow?.id || '').trim();
    const isLepas = isRowLepasToGudang(ketLepasTargetRow);
    const nextKet = String(ketLepasDraft || '').trim() || '';
    const nextCatatan = String(catatanDraft || '').trim();
    const nextIndikasiRaw = String(indikasiDraft || '').trim();
    const nextTindakLanjut = String(tindakLanjutDraft || '').trim();
    const nextNamaSopir = String(namaSopirDraft || '').trim();
    const nextIndikasi = nextKet === 'Normal'
      ? 'Normal'
      : (nextIndikasiRaw || 'Normal');
    if (isLepas && !nextKet) {
      showNotif('error', 'Kondisi Ban Saat Lepas wajib dipilih.');
      return;
    }
    if (isLepas && !nextCatatan) {
      showNotif('error', 'Catatan Lepas wajib diisi.');
      return;
    }
    if (!idRow) return;
    setRiwayatPerubahanRows((prev) => prev.map((item) => (
      String(item?.id || '').trim() === idRow
        ? {
            ...item,
            catatan: nextCatatan,
            ban_defect: isLepas ? nextKet : '',
            indikasi: isLepas ? nextIndikasi : '',
            tindak_lanjut: isLepas ? nextTindakLanjut : '',
            sopir: isLepas ? nextNamaSopir : '',
          }
        : item
    )));
    setOpenKetLepasModal(false);
  };
  const positionDefectTooltip = (event, text) => {
    const tooltipWidth = 320;
    const tooltipHeight = 120;
    const vw = typeof window !== "undefined" ? window.innerWidth : 1366;
    const vh = typeof window !== "undefined" ? window.innerHeight : 768;
    const baseX = Number(event?.clientX || 0);
    const baseY = Number(event?.clientY || 0);

    let x = baseX;
    let y = baseY + 20;

    setDefectTooltip({
      visible: true,
      text: String(text || "").trim(),
      x,
      y,
    });
  };
  const handleDragStateChange = (payload = {}) => {
    setDragMonitor({
      active: Boolean(payload?.active),
      source: payload?.source || null,
      target: payload?.target || null,
      hasPair: Boolean(payload?.hasPair),
    });
  };
  const handleGudangMouseDown = (row, event) => {
    if (event?.button !== 0) return;
    const idBan = Number(row?.id_ban || 0);
    if (!idBan) return;
    hideBanTooltip();
    gudangDragStartRef.current = { x: Number(event?.clientX || 0), y: Number(event?.clientY || 0) };
    gudangDragMovedRef.current = false;
    const seri = String(row?.seri_ban || resolveBanSeri(idBan) || `ID ${idBan}`).trim();
    setGudangDrag({
      active: true,
      idBan,
      seriBan: seri,
      x: Number(event?.clientX || 0),
      y: Number(event?.clientY || 0),
      hasPair: false,
      target: null,
    });
    setDragMonitor({
      active: true,
      source: { owner: 'gudang', pos: String(idBan), id_ban: idBan, label: seri },
      target: null,
      hasPair: false,
    });
  };
  useEffect(() => {
    if (!gudangDrag.active) return undefined;
    const onMouseMove = (event) => {
      const x = Number(event?.clientX || 0);
      const y = Number(event?.clientY || 0);
      const dx = Math.abs(x - Number(gudangDragStartRef.current?.x || 0));
      const dy = Math.abs(y - Number(gudangDragStartRef.current?.y || 0));
      if (!gudangDragMovedRef.current && (dx > gudangDragMoveThreshold || dy > gudangDragMoveThreshold)) {
        gudangDragMovedRef.current = true;
      }
      const hit = document.elementFromPoint(x, y);
      const slotRaw = hit?.closest?.('[data-drop-slot]')?.getAttribute?.('data-drop-slot');
      const zoneRaw = hit?.closest?.('[data-drop-zone]')?.getAttribute?.('data-drop-zone');
      const slot = parseDropSlot(slotRaw);
      const zone = parseDropZone(zoneRaw);
      const validSlot = Boolean(slot && (slot.owner === 'mt1' || slot.owner === 'mt2'));
      const targetMeta = validSlot
        ? { kind: 'slot', owner: slot.owner, pos: slot.pos }
        : (zone ? { kind: 'zone', owner: zone.owner, zone: zone.zone } : null);
      const hasPair = validSlot;
      setGudangDrag((prev) => ({
        ...prev,
        x,
        y,
        hasPair,
        target: targetMeta,
      }));
      setDragMonitor({
        active: true,
        source: { owner: 'gudang', pos: String(gudangDrag.idBan), id_ban: gudangDrag.idBan, label: gudangDrag.seriBan },
        target: targetMeta,
        hasPair,
      });
    };
    const onMouseUp = () => {
      if (!gudangDragMovedRef.current) {
        setGudangDrag({
          active: false,
          idBan: 0,
          seriBan: '',
          x: 0,
          y: 0,
          hasPair: false,
          target: null,
        });
        setDragMonitor({ active: false, source: null, target: null, hasPair: false });
        return;
      }
      const target = gudangDrag?.target || null;
      handleFormasiDragDrop({
        source: {
          owner: 'gudang',
          pos: String(gudangDrag?.idBan || ''),
          id_ban: Number(gudangDrag?.idBan || 0),
          label: String(gudangDrag?.seriBan || '').trim(),
        },
        target,
      });
      setGudangDrag({
        active: false,
        idBan: 0,
        seriBan: '',
        x: 0,
        y: 0,
        hasPair: false,
        target: null,
      });
      setDragMonitor({ active: false, source: null, target: null, hasPair: false });
      gudangDragMovedRef.current = false;
    };
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp, { once: true });
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, [gudangDrag.active, gudangDrag.idBan, gudangDrag.seriBan, gudangDrag.target, handleFormasiDragDrop]);
  const openLampiran = (index) => {
    const files = daftarLampiran
      .filter((item) => Boolean(item?.path))
      .map((item, idx) => ({
        url: String(item.path).startsWith('http') ? item.path : `${backendPort}${item.path}`,
        caption: item?.caption || item?.name || `Lampiran ${idx + 1}`,
        name: item?.name || `Lampiran ${idx + 1}`,
        note: `${editData?.id_mt || ''} - ${item?.caption || item?.name || `Lampiran ${idx + 1}`}`.trim(),
      }));
    if (files.length === 0) return;

    const safeIndex = Number(index);
    const orderedFiles = Number.isFinite(safeIndex) && safeIndex >= 0 && safeIndex < files.length
      ? [files[safeIndex], ...files.filter((_, idx) => idx !== safeIndex)]
      : files;

    setSelectedLampiranFiles(orderedFiles);
    setOpenLampiranModal(true);
  };
  const openPosisiHistoryModal = () => {
    setShowPosisiHistoryModal(true);
    const first = posisiList[0] || '';
    setSelectedHistoryPosisi(first);
  };
  const handleOpenPilihBanGudang = async () => {
    const kodeCabang = String(selectedCabang || '').trim();
    if (!kodeCabang) {
      showNotif('error', 'Pilih cabang terlebih dahulu.');
      return;
    }
    setOpenPilihBanGudangModal(true);
  };
  const handleSelesaiPilihBanGudang = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const normalizedRows = (Array.isArray(rows) ? rows : [])
      .map((row) => ({
        id_ban: Number(row?.id_ban || 0),
        seri_ban: String(row?.seri_ban || '').trim(),
        status: String(row?.status || row?.status_now || '').trim(),
      }))
      .filter((row) => row.id_ban > 0);

    setSelectedGudangBanIds(normalizedIds);
    setSelectedGudangBanRows(normalizedRows);
    if ((riwayatPerubahanRows || []).length === 0) {
      saveBaselineState(daftarBanMapMt1, daftarBanMapMt2, normalizedRows, normalizedIds);
      setInitialPlaceByBanId(buildInitialPlaceSnapshot(daftarBanMapMt1, daftarBanMapMt2, normalizedRows));
    }
  };
  const handleClearPerubahan = () => {
    if (baselineState) {
      const resetMapMt1 = { ...(baselineState?.mapMt1 || {}) };
      const resetMapMt2 = { ...(baselineState?.mapMt2 || {}) };
      const resetGudangRows = [...(baselineState?.gudangRows || [])].map((row) => ({ ...(row || {}) }));
      const resetGudangIds = [...(baselineState?.gudangIds || [])];
      setDaftarBanMapMt1(resetMapMt1);
      setDaftarBanMapMt2(resetMapMt2);
      setSelectedGudangBanRows(resetGudangRows);
      setSelectedGudangBanIds(resetGudangIds);
      setInitialPlaceByBanId({ ...(baselineState?.initialPlace || {}) });
      syncRepairRowsToFinalPlaces(resetMapMt1, resetMapMt2, resetGudangRows);
    }
    setRiwayatPerubahanRows([]);
    setOpenStatusBanModal(false);
    setStatusBanTargetRow(null);
    setStatusBanDraftNext('');
    setBeritaAcaraByBanId({});
    setInvalidBeritaAcaraCaptionIndexesByBanId({});
    setOpenKetLepasModal(false);
    setKetLepasTargetRow(null);
    setKetLepasDraft('');
    setIndikasiDraft('');
    setCatatanDraft('');
    setInvalidCaptionIndexes([]);
  };
  const collectInvalidCaptionIndexes = () => (
    (Array.isArray(attachments) ? attachments : [])
      .map((item, idx) => (String(item?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  const collectInvalidRepairCaptionsByBanId = () => {
    const invalid = {};
    validRepairRows.forEach((row) => {
      const key = String(Number(row?.id_ban || 0));
      const indexes = (repairAttachmentsByBanId?.[key] || [])
        .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
        .filter((idx) => idx >= 0);
      if (indexes.length > 0) invalid[key] = indexes;
    });
    return invalid;
  };
  const collectInvalidBeritaAcaraCaptionByBanId = () => {
    const next = {};
    validPerubahanRows.forEach((row) => {
      const key = getBeritaAcaraKey(row);
      if (!key) return;
      const validation = validateStatusLampiranForRow(row, row?.status_akhir);
      if (validation.invalid) {
        next[key] = validation.invalidCaptions.length ? validation.invalidCaptions : [-1];
      }
    });
    return next;
  };
  const handleSubmitRotasiGabungan = async () => {
    if (submitLockRef.current) return;
    if (!bisaSubmitDasar) {
      showNotif('error', blockedRepairRow?.repair_blocked_reason || 'Tambahkan perubahan posisi atau pilih minimal satu ban repair, lalu lengkapi detail repair bila ada.');
      return;
    }
    if (isStoringRotasiContext && !storingLastCheckReady) {
      showNotif('error', storingLastCheckLoading
        ? 'Last Check sedang dimuat. Tunggu hingga status ODO dan TD tampil.'
        : 'Update ODO MT terkait dan Update TD ban terkait wajib dilakukan hari ini.');
      return;
    }
    const idMtPrimary = String(idMt1 || '').trim();
    if (!idMtPrimary) {
      showNotif('error', 'ID MT utama tidak ditemukan.');
      return;
    }
    const tanggalInput = String(editData?.tanggal_input || editData?.tanggal || formatYYYYMMDD(new Date())).trim();
    const waktuMulai = String(editData?.start || '').trim();
    const waktuSelesai = String(editData?.end || '').trim();
    if (!tanggalInput || !waktuMulai || !waktuSelesai) {
      showNotif('error', 'Tanggal, waktu mulai, dan waktu selesai wajib tersedia.');
      return;
    }
    if (waktuMulai >= waktuSelesai) {
      showNotif('error', 'Waktu selesai harus lebih besar dari waktu mulai.');
      return;
    }
    if (hasRotasiSubmit) {
      const invalidIndexes = collectInvalidCaptionIndexes();
      if (invalidIndexes.length > 0) {
        setInvalidCaptionIndexes(invalidIndexes);
        showNotif('error', 'Caption dokumen wajib diisi untuk semua lampiran perubahan posisi.');
        return;
      }
    }
    if (blockedRepairRow) {
      showNotif('error', blockedRepairRow.repair_blocked_reason);
      return;
    }
    if (!repairRowsShapeValid || !repairRowsValid) {
      showNotif('error', 'Lengkapi jenis tambal, quantity 0 sampai 4, dan status akhir pada setiap ban repair.');
      return;
    }
    if (hasRepairSubmit) {
      const invalidRepairByBan = collectInvalidRepairCaptionsByBanId();
      const invalidRepairBanId = Number(Object.keys(invalidRepairByBan)[0] || 0);
      if (invalidRepairBanId > 0) {
        setActiveRepairDetailBanId(invalidRepairBanId);
        setOpenRepairDetailModal(true);
        showNotif('error', `Caption dokumen repair ban ${invalidRepairBanId} wajib diisi.`);
        return;
      }
    }
    if (hasRotasiSubmit) {
      const invalidBaCaptions = collectInvalidBeritaAcaraCaptionByBanId();
      if (Object.keys(invalidBaCaptions).length > 0) {
        setInvalidBeritaAcaraCaptionIndexesByBanId(invalidBaCaptions);
        showNotif('error', 'Upload BA Analisa wajib diisi untuk status Afkir, dan caption dokumen wajib diisi untuk lampiran perubahan status.');
        return;
      }
      const missingLepasDefect = validPerubahanRows.find((row) => isRowLepasToGudang(row) && !String(row?.ban_defect || '').trim());
      if (missingLepasDefect) {
        showNotif('error', `Kondisi Ban Saat Lepas wajib diisi untuk ban ${missingLepasDefect?.seri_ban || missingLepasDefect?.id_ban || '-'}.`);
        return;
      }
      const missingLepasCatatan = validPerubahanRows.find((row) => isRowLepasToGudang(row) && !String(row?.catatan || '').trim());
      if (missingLepasCatatan) {
        showNotif('error', `Catatan Lepas wajib diisi untuk ban ${missingLepasCatatan?.seri_ban || missingLepasCatatan?.id_ban || '-'}.`);
        return;
      }
    }
    setInvalidCaptionIndexes([]);
    try {
      submitLockRef.current = true;
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('nomorWO', String(editData?.nomor_wo || '').trim());
      formData.append('tanggal', tanggalInput);
      formData.append('kode_cabang', String(selectedCabang || editData?.kode_cabang || '').trim());
      formData.append('start', waktuMulai);
      formData.append('end', waktuSelesai);
      formData.append('user', actorNama);
      formData.append('id_mt_1', idMtPrimary);
      const repairInMt2 = validRepairRows.some((row) => String(row?.id_mt || '').trim() === String(idMt2 || '').trim());
      formData.append('id_mt_2', (mtTerlibatSubmit.mt2 || repairInMt2) ? String(idMt2 || '').trim() : '');
      formData.append('event_tipe', String(tipeEventSubmit || '').trim());
      formData.append('context_mode', isStoringRotasiContext ? 'storing_rotasi' : '');
      formData.append('lokasi', String(editData?.lokasi || '').trim());
      formData.append('jarak', String(editData?.jarak || '').trim());
      formData.append('rows', JSON.stringify(validPerubahanRows));
      formData.append('repair_rows', JSON.stringify(validRepairRows));
      formData.append('map_mt1', JSON.stringify(daftarBanMapMt1 || {}));
      formData.append('map_mt2', JSON.stringify((mtTerlibatSubmit.mt2 || repairInMt2) ? (daftarBanMapMt2 || {}) : {}));
      if (hasRotasiSubmit) {
        attachments.forEach((item) => {
          if (item?.file instanceof File) formData.append('files', item.file);
          formData.append('captions', String(item?.caption || '').trim());
        });
      }
      validRepairRows.forEach((row) => {
        const idBan = String(Number(row?.id_ban || 0));
        (repairAttachmentsByBanId?.[idBan] || []).forEach((item) => {
          if (!(item?.file instanceof File)) return;
          formData.append('repair_files', item.file);
          formData.append('repair_captions', String(item?.caption || '').trim());
          formData.append('repair_id_ban', idBan);
        });
      });
      if (hasRotasiSubmit) {
        validPerubahanRows.forEach((row) => {
          const key = getBeritaAcaraKey(row);
          if (!key) return;
          (beritaAcaraByBanId[key] || []).forEach((item) => {
            if (!(item?.file instanceof File)) return;
            formData.append('ba_files', item.file);
            formData.append('ba_captions', String(item?.caption || '').trim());
            formData.append('ba_id_ban', key);
          });
        });
      }
      await api.post(`${backendPort}/api/main/submit_rotasi_gabungan_mt`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        requestGroup: REQ_GROUP_ROTASI_SUBMIT,
        timeout: 120000,
      });
      showNotif('success', hasRotasiSubmit && hasRepairSubmit
        ? 'Rotasi dan repair ban berhasil disimpan.'
        : (hasRepairSubmit ? 'Repair ban berhasil disimpan.' : 'Perubahan rotasi/ganti ban berhasil disimpan.'));
      if (typeof onSubmitSuccess === 'function') {
        onSubmitSuccess();
      } else {
        close();
      }
    } catch (err) {
      if (api.isCanceledError?.(err)) return;
      console.error(err);
      showNotif('error', err?.response?.data?.message || 'Gagal menyimpan perubahan rotasi/ganti ban.');
    } finally {
      submitLockRef.current = false;
      setIsSubmitting(false);
    }
  };

  return(
    <div ref={rootRef} className="col-md-12 page9edit-shell">
      <ShowPic
        open={openLampiranModal}
        onClose={() => setOpenLampiranModal(false)}
        row={{ catatan: selectedLampiranFiles?.[0]?.caption || "" }}
        backendPort={backendPort}
        token=""
        onUploadSuccess={() => {}}
        readOnly={true}
        customTitle="Lampiran MT"
        customNote={selectedLampiranFiles?.[0]?.caption || ""}
        customFileUrl={selectedLampiranFiles?.[0]?.url || null}
        customFiles={selectedLampiranFiles}
      />
      <ModalCariBanMulti
        open={openPilihBanGudangModal}
        onClose={() => setOpenPilihBanGudangModal(false)}
        onSubmit={handleSelesaiPilihBanGudang}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={selectedCabang}
        title="Pilih Ban - Perubahan Status BAN"
        subtitle="Filter lokasi dikunci ke Gudang. Filter OTF dan Pabrik nonaktif; ubah hanya filter Status."
        initialSelectedIds={selectedGudangBanIds}
        initialSelectedRows={selectedGudangBanRows}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATIONS_NON_GUDANG}
      />
      {gudangDrag.active && (
        <div
          style={{
            position: 'fixed',
            left: `${gudangDrag.x + 14}px`,
            top: `${gudangDrag.y + 14}px`,
            zIndex: 9999,
            pointerEvents: 'none',
            minWidth: '120px',
            padding: '6px 10px',
            borderRadius: '12px',
            background: gudangDrag.hasPair
              ? 'linear-gradient(145deg, #22c55e 0%, #15803d 100%)'
              : 'linear-gradient(145deg, #f59e0b 0%, #f97316 100%)',
            border: `2px solid ${gudangDrag.hasPair ? '#166534' : '#92400e'}`,
            color: '#f8fafc',
            fontWeight: 700,
            fontSize: '0.85rem',
            boxShadow: '0 10px 24px rgba(0,0,0,0.28)',
            transform: 'translate(-20%, -45%)',
          }}
        >
          {gudangDrag.seriBan || '-'}
        </div>
      )}
      {hoverBanTooltip.visible && hoverBanData && (
        <div
          style={{
            position: 'fixed',
            left: `${Number(hoverBanTooltip.x || 0) + 14}px`,
            top: `${Number(hoverBanTooltip.y || 0) + 14}px`,
            zIndex: 9998,
            pointerEvents: 'none',
            minWidth: '220px',
            maxWidth: '280px',
            padding: '10px 12px',
            borderRadius: '10px',
            border: '1px solid #0f172a',
            background: 'rgba(15, 23, 42, 0.96)',
            color: '#e2e8f0',
            boxShadow: '0 10px 24px rgba(2,6,23,0.35)',
            fontSize: '0.78rem',
            lineHeight: 1.45,
          }}
        >
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Seri</span>
            <span style={{ fontWeight: 700, textAlign: 'right' }}>{hoverBanData.seri || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Status</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.status || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>KM Tempuh</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.km || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>TD</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.td || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Indikasi</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverIndikasiText}</span>
          </div>
        </div>
      )}
      <div className="card page9edit-card">
        <div className="card-header d-flex justify-content-between align-items-center page9edit-header text-white">
          <div className="d-flex align-items-center flex-wrap">
            <span className="fw-semibold">{teksHeaderRotasi}</span>
          </div>
          <div className="d-flex align-items-center gap-2 flex-nowrap">
          <button type="button" className="btn btn-sm btn-outline-light page9show-close-btn" onClick={close}>
            Batal
          </button>
          </div>
        </div>
        <div className="card-body page9edit-body">
          <form className="page9edit-form">
            <div className='row g-3'>
              <div className={isDualMt ? 'col-md-6' : 'col-md-4'}>
                <div className="card p-3 page9edit-step-card" id='box-formasi' data-drop-zone="workspace:box_formasi">
                  <h5 className="page9edit-step-title mb-2">Formasi Ban</h5>
                  <div className="card mb-3 p-3 page9edit-step-card w-100" data-drop-zone="gudang:list">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p className="page9edit-step-title mb-0">Ambil Stok Gudang</p>
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleOpenPilihBanGudang}>
                        Pilih Ban
                      </button>
                    </div>
                    <small className="text-muted">
                      {`Terpilih: ${selectedGudangBanRows.length} ban`}
                    </small>
                    {selectedGudangBanRows.length > 0 && (
                      <div className="row g-2 mt-1">
                        {selectedGudangBanRows.map((row) => (
                          <div key={`selected-gudang-ban-${row.id_ban}`} className={isDualMt ? 'col-2' : 'col-4'} data-drop-slot={`gudang:${row.id_ban}`}>
                            {(() => {
                              const rowId = Number(row?.id_ban || 0);
                              const rowSeri = String(row?.seri_ban || '').trim().toUpperCase();
                              const isChangedGudang = changedBanIdSet.has(rowId) || changedBanSeriSet.has(rowSeri);
                              const isSourceGudang = (
                                dragMonitor?.active
                                && String(dragMonitor?.source?.owner || '').trim() === 'gudang'
                                && Number(dragMonitor?.source?.id_ban || 0) === rowId
                              );
                              const isTargetGudang = (
                                dragMonitor?.active
                                && dragMonitor?.target?.kind === 'slot'
                                && String(dragMonitor?.target?.owner || '').trim() === 'gudang'
                                && String(dragMonitor?.target?.pos || '').trim() === String(rowId)
                              );
                              const bg = isSourceGudang
                                ? (dragMonitor?.hasPair
                                  ? 'linear-gradient(145deg, #22c55e 0%, #15803d 100%)'
                                  : 'linear-gradient(145deg, #f59e0b 0%, #f97316 100%)')
                                : (isTargetGudang
                                  ? 'linear-gradient(145deg, #22c55e 0%, #15803d 100%)'
                                  : (isChangedGudang
                                    ? 'linear-gradient(145deg, #22c55e 0%, #15803d 100%)'
                                    : 'linear-gradient(145deg, #2f6ea3 0%, #1d4f79 100%)'));
                              const border = isSourceGudang
                                ? (dragMonitor?.hasPair ? '#166534' : '#92400e')
                                : (isTargetGudang ? '#166534' : (isChangedGudang ? '#166534' : '#133f66'));
                              return (
                            <div
                              className="card h-100"
                              onMouseDown={(e) => handleGudangMouseDown(row, e)}
                              onMouseEnter={(e) => showBanTooltip({
                                owner: 'gudang',
                                pos: String(rowId),
                                id_ban: rowId,
                                x: Number(e?.clientX || 0),
                                y: Number(e?.clientY || 0),
                              })}
                              onMouseMove={(e) => showBanTooltip({
                                owner: 'gudang',
                                pos: String(rowId),
                                id_ban: rowId,
                                x: Number(e?.clientX || 0),
                                y: Number(e?.clientY || 0),
                              })}
                              onMouseLeave={hideBanTooltip}
                              data-ban-hover="1"
                              style={{
                                border: `2px solid ${border}`,
                                background: bg,
                                color: '#f8fafc',
                                cursor: 'grab',
                              }}
                            >
                              <div
                                className="card-body py-2 px-2 small"
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  color: '#f8fafc',
                                  fontWeight: 700,
                                  fontSize: '0.78rem',
                                }}
                              >
                                {`${row.seri_ban || '-'}`}
                              </div>
                            </div>
                              );
                            })()}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="row g-3">
                    <div className={isDualMt ? "col-6" : "col-12"} id='mt-1'>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="fw-semibold small">MT 1</span>
                        <span className="badge text-bg-light border">{`No Pol: ${nopolMt1 || '-'}`}</span>
                      </div>
                      <FormasiBanDraggable
                        formasi={formasiMt1}
                        cadangan={cadanganMt1}
                        onDragDrop={handleFormasiDragDrop}
                        onDragStateChange={handleDragStateChange}
                        onSelectBan={(posisi) => handleRepairBanImageClick('mt1', posisi)}
                        onBanHover={showBanTooltip}
                        onBanLeave={hideBanTooltip}
                        resolveDragLabel={({ id_ban }) => resolveBanSeri(id_ban) || `ID ${id_ban}`}
                        highlightedPosisi={changedPosisiMt.mt1}
                        warningPosisi={tdWarningPosisiMt1}
                        unevenWearPosisi={unevenWearPosisiMt1}
                        highlightedStyle="success"
                        externalTargetPos={targetMt1Pos}
                        externalTargetActive={Boolean(targetMt1Pos)}
                        dragOwner="mt1"
                        daftarKodeBan={daftarBanMapMt1}
                      />
                    </div>
                    {isDualMt && (
                      <div className="col-6" id='mt-2'>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="fw-semibold small">MT 2</span>
                          <span className="badge text-bg-light border">{`No Pol: ${nopolMt2 || '-'}`}</span>
                        </div>
                        <FormasiBanDraggable
                          formasi={formasiMt2}
                          cadangan={cadanganMt2}
                          onDragDrop={handleFormasiDragDrop}
                          onDragStateChange={handleDragStateChange}
                          onSelectBan={(posisi) => handleRepairBanImageClick('mt2', posisi)}
                          onBanHover={showBanTooltip}
                          onBanLeave={hideBanTooltip}
                          resolveDragLabel={({ id_ban }) => resolveBanSeri(id_ban) || `ID ${id_ban}`}
                          highlightedPosisi={changedPosisiMt.mt2}
                          warningPosisi={tdWarningPosisiMt2}
                          unevenWearPosisi={unevenWearPosisiMt2}
                          highlightedStyle="success"
                          externalTargetPos={targetMt2Pos}
                          externalTargetActive={Boolean(targetMt2Pos)}
                          dragOwner="mt2"
                          daftarKodeBan={daftarBanMapMt2}
                        />
                      </div>
                    )}
                  </div>

                </div>
              </div>
              <div className={isDualMt ? 'col-md-6' : 'col-md-8'} id='kolom-perubahan'>
                <div className="page9show-stack">
                  <div className="card p-3 page9edit-step-card" id='perubahan-posisi'>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p className="page9edit-step-title mb-0">Perubahan Posisi</p>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handleClearPerubahan}
                      >
                        Clear
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: '0.89rem' }}>
                        <thead className="table-light">
                          <tr>
                            <th>Seri Ban</th>
                            <th>Posisi Awal</th>
                            <th>Posisi Akhir</th>
                            <th>Event</th>
                            <th>Catatan</th>
                            <th style={{ width: 120 }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {riwayatPerubahanRows.length === 0 && (
                            <tr>
                              <td colSpan={6} className="text-center text-muted">Belum ada histori perubahan.</td>
                            </tr>
                          )}
                          {riwayatPerubahanRows.map((row) => (
                            <tr key={row.id}>
                              <td>{row?.seri_ban || '-'}</td>
                              <td>{renderPlaceCell(row?.posisi_awal)}</td>
                              <td>{renderPlaceCell(row?.posisi_akhir)}</td>
                              <td>
                                <div style={{ lineHeight: 1.15 }}>
                                  <div>{row?.event || '-'}</div>
                                  {isRowLepasToGudang(row) && String(row?.kmt_otf ?? '').trim() !== '' && (
                                    <div className="text-muted">
                                      {`${Number(row?.kmt_otf || 0).toLocaleString('id-ID')} KM`}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                {(() => {
                                  const isLepasRow = isRowLepasToGudang(row);
                                  const catatanValue = String(row?.catatan || '');
                                  const catatanTrim = catatanValue.trim();
                                  const inputClass = isLepasRow && !catatanTrim
                                    ? 'form-control form-control-sm bg-warning-subtle border-warning'
                                    : 'form-control form-control-sm bg-primary-subtle border-primary';
                                  return (
                                <input
                                  type="text"
                                  className={inputClass}
                                  placeholder="Catatan"
                                  onClick={() => openKetLepasEditor(row)}
                                  value={catatanValue}
                                  readOnly
                                />
                                  );
                                })()}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary w-100 text-start"
                                  title="Ubah status ban"
                                  onClick={() => openStatusEditor(row)}
                                >
                                  {formatStatusButtonLabel(row?.status_awal, row?.status_akhir)}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-3 border-top pt-3">
                      <div className="fw-semibold small mb-2">Lampiran Perubahan Posisi</div>
                      {daftarLampiran.filter((item) => Boolean(item?.path)).length > 0 && (
                        <div className="page9show-list mb-3">
                          {daftarLampiran.filter((item) => Boolean(item?.path)).map((item, idx) => (
                            <StatRow
                              key={`lampiran-eksisting-${idx}`}
                              label={String(item?.caption || '').trim() || '-'}
                              secondaryLabel={String(item?.name || `Lampiran ${idx + 1}`).trim()}
                              variant={buildLampiranUrl(item?.path) !== '#' ? 'link' : 'neutral'}
                              onClick={() => {
                                if (buildLampiranUrl(item?.path) !== '#') openLampiran(idx);
                              }}
                            />
                          ))}
                        </div>
                      )}
                      <PageKonten9_Pict
                        attachments={attachments}
                        setAttachments={setAttachments}
                        bisaInput={true}
                        invalidCaptionIndexes={invalidCaptionIndexes}
                        onCaptionChange={() => {
                          if (!invalidCaptionIndexes.length) return;
                          setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
                        }}
                      />
                    </div>
                  </div>
                  <div className="card p-3 page9edit-step-card mt-3" id="repair-tambal-ban">
                    <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                      <p className="page9edit-step-title mb-0">Repair / Tambal Ban</p>
                      <small className="text-muted">Pilih ban repair dengan klik gambar.</small>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: '0.84rem' }}>
                        <thead className="table-light"><tr><th>Ban / Posisi</th><th>Status Akhir</th><th>Keterangan</th><th>Hapus</th></tr></thead>
                        <tbody>
                          {repairRows.length === 0 && <tr><td colSpan={4} className="text-center text-muted">Belum ada ban repair.</td></tr>}
                          {repairRows.map((row) => (
                            <tr key={`repair-${row.id_ban}`}>
                              <td>
                                <div>{row.seri_ban || `ID ${row.id_ban}`}</div>
                                <small className="text-muted">{`${resolveNopolByIdMt(row.id_mt)} | ${row.posisi}`}</small>
                                {row.repair_blocked_reason && <small className="d-block text-danger fw-semibold">{row.repair_blocked_reason}</small>}
                              </td>
                              <td><select className="form-select form-select-sm" value={row.status_baru} onChange={(e) => updateMirroredBanStatus(row.id_ban, e.target.value)}><option value="">Pilih Status</option>{getRepairStatusOptions(row).map((item) => <option key={`repair-status-${row.id_ban}-${item}`} value={item}>{item}</option>)}</select></td>
                              <td><button type="button" className={`form-control form-control-sm text-start ${(!row.jenis_tambal || !Number.isFinite(Number(row.qty_tambal)) || Number(row.qty_tambal) < 0 || Number(row.qty_tambal) > 4) ? 'field-required-invalid' : ''}`} onClick={() => openRepairDetailEditor(row)}>{row.catatan || row.jenis_tambal || row.bahan_tambal || (repairAttachmentsByBanId?.[String(row.id_ban)] || []).length ? [row.jenis_tambal, `Qty ${row.qty_tambal}`, row.bahan_tambal, row.catatan, `Lampiran ${(repairAttachmentsByBanId?.[String(row.id_ban)] || []).length}`].filter(Boolean).join(' | ') : 'Isi keterangan'}</button></td>
                              <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeRepairRow(row.id_ban)}>Hapus</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {isStoringRotasiContext && (
                    <div className="card p-3 page16-info-card mt-3" id="storing-last-check">
                      <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                        <p className="page16-info-title mb-0">LAST CHECK</p>
                        {storingLastCheckLoading && <small className="text-muted">Memuat...</small>}
                      </div>
                      {storingLastCheckTargets.map(({ idMt, tdBans }) => {
                        const check = storingLastCheckByMt?.[idMt] || {};
                        const tdRows = Array.isArray(check?.tdBans) ? check.tdBans : [];
                        return (
                          <div key={`storing-last-check-${idMt}`} className="border rounded p-2 mb-2">
                            <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                              <span className="fw-semibold small">{resolveNopolByIdMt(idMt)}</span>
                              <small className="text-muted">{idMt}</small>
                            </div>
                            <div className="row g-2">
                              <div className="col-12 col-md-6">
                                <div className="d-grid gap-1">
                                  <button
                                    type="button"
                                    className="btn page16-gradient-btn text-white fw-bold"
                                    onClick={() => setStoringLastCheckModal({ action: 'odo', idMt })}
                                  >
                                    {storingLastCheckLoading ? 'Memuat ODO...' : `ODO: ${Number(check?.odoValue || 0).toLocaleString('id-ID')}`}
                                  </button>
                                  <small className={check?.odoToday ? 'text-success' : 'text-danger'}>
                                    {`Check: ${formatTglUntukUI(check?.odoToday ? check?.serverDate : check?.odoDate)}`}
                                  </small>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div className="d-grid gap-1">
                                  <button
                                    type="button"
                                    className="btn page16-gradient-btn text-white fw-bold"
                                    onClick={() => setStoringLastCheckModal({ action: 'td', idMt })}
                                  >
                                    {`TD ban terkait: ${tdBans.length} ban`}
                                  </button>
                                  {tdBans.length === 0 ? (
                                    <small className="text-muted">Tidak ada ban sumber MT yang wajib Update TD pada transaksi ini.</small>
                                  ) : tdBans.map((ban) => {
                                    const tdCheck = tdRows.find((item) => item.idBan === ban.idBan) || {};
                                    return (
                                      <small key={`storing-last-check-td-${idMt}-${ban.idBan}`} className={tdCheck?.tdToday ? 'text-success' : 'text-danger'}>
                                        {`${ban.posisi} | ${resolveBanSeri(ban.idBan) || `ID ${ban.idBan}`} | Check: ${formatTglUntukUI(tdCheck?.tdToday ? check?.serverDate : tdCheck?.tdDate)}`}
                                      </small>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <small className="text-danger fst-italic fw-light d-block mt-1">
                        Update ODO wajib untuk MT terkait, dan Update TD wajib untuk ban terkait.
                      </small>
                    </div>
                  )}
                  <div className="col-12 mt-3">
                    <div className="card page16-verify-card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-2 align-items-center">
                          <div className="col-12 col-md-8">
                            <span className="fw-semibold">Petugas Input</span>
                          </div>
                          <div className="col-12 col-md-4 ms-md-auto">
                            <input
                              type="text"
                              className="form-control"
                              value={petugasInput}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmitRotasiGabungan}
                disabled={!bisaSubmit || isSubmitting}
                title={!bisaSubmit ? (isStoringRotasiContext && !storingLastCheckReady
                  ? (storingLastCheckLoading ? 'Last Check sedang dimuat.' : 'Update ODO MT terkait dan Update TD ban terkait wajib hari ini.')
                  : (blockedRepairRow?.repair_blocked_reason || 'Tambahkan perubahan posisi atau pilih ban repair, lalu lengkapi detail repair.')) : ''}
              >
                {isSubmitting ? 'Menyimpan...' : submitLabel}
              </button>
            </div>
          </form>
        </div>
      </div>
      {storingLastCheckModal.action === 'odo' && storingLastCheckModal.idMt && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: 'min(1180px, 97vw)' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={globalOpsi}
              resendToken={reloadToken}
              mode="modal"
              forcedAction="odo"
              presetMtId={storingLastCheckModal.idMt}
              presetKodeCabang={selectedCabang}
              presetTanggal={storingLastCheckByMt?.[storingLastCheckModal.idMt]?.serverDate || formatYYYYMMDD(new Date())}
              onClose={() => setStoringLastCheckModal({ action: '', idMt: '' })}
              onAfterSave={() => {
                setStoringLastCheckModal({ action: '', idMt: '' });
                setStoringLastCheckRefreshTick((prev) => prev + 1);
              }}
            />
          </div>
        </div>
      )}
      {storingLastCheckModal.action === 'td' && storingLastCheckModal.idMt && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '97vw' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={globalOpsi}
              resendToken={reloadToken}
              mode="modal"
              forcedAction="td"
              presetMtId={storingLastCheckModal.idMt}
              presetKodeCabang={selectedCabang}
              presetTanggal={storingLastCheckByMt?.[storingLastCheckModal.idMt]?.serverDate || formatYYYYMMDD(new Date())}
              onClose={() => setStoringLastCheckModal({ action: '', idMt: '' })}
              onAfterSave={() => {
                setStoringLastCheckModal({ action: '', idMt: '' });
                setStoringLastCheckRefreshTick((prev) => prev + 1);
              }}
            />
          </div>
        </div>
      )}
      <ModalRepairDetail
        open={openRepairDetailModal}
        row={activeRepairDetailRow}
        attachments={activeRepairAttachments}
        opsiJenisTambal={opsiJenisTambal}
        opsiBahanTambal={opsiBahanTambal}
        onClose={() => {
          setOpenRepairDetailModal(false);
          setActiveRepairDetailBanId(0);
        }}
        onSave={({ attachments: savedAttachments = [], ...detail }) => {
          const key = String(Number(activeRepairDetailBanId || 0));
          updateRepairRow(activeRepairDetailBanId, detail);
          setRepairAttachmentsByBanId((prev) => ({
            ...(prev || {}),
            [key]: (Array.isArray(savedAttachments) ? savedAttachments : []).map((item) => ({ ...(item || {}) })),
          }));
          setOpenRepairDetailModal(false);
          setActiveRepairDetailBanId(0);
        }}
      />
      {openStatusBanModal && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Perubahan Status Ban</h5>
                  <button type="button" className="btn-close" onClick={() => setOpenStatusBanModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <div className="small text-muted mb-1">{`Ban: ${statusBanTargetRow?.id_ban || "-"} | ${statusBanTargetRow?.seri_ban || "-"}`}</div>
                  </div>
                  <div className="mb-3">
                    <div className="small text-muted mb-1">Status Saat Ini</div>
                    <div className="fw-semibold">{statusBanTargetRow?.status_awal || "-"}</div>
                  </div>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    {statusBanOptions.map((opt) => (
                      <button
                        key={`status-opt-${opt}`}
                        type="button"
                        className={`btn btn-sm ${statusBanDraftNext === opt ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setStatusBanDraftNext(opt)}
                      >
                        {opt}
                      </button>
                    ))}
                  </div>
                  <div className="small text-muted">{`Status Terpilih: ${statusBanDraftNext || "-"}`}</div>
                  {(() => {
                    const selectedIsAfkir = normalizeStatusText(statusBanDraftNext) === 'AFKIR';
                    const lampiranKey = getBeritaAcaraKey(statusBanTargetRow);
                    const lampiranStatus = getBeritaAcaraAttachments(statusBanTargetRow);
                    const invalidIndexesRaw = invalidBeritaAcaraCaptionIndexesByBanId[lampiranKey] || [];
                    const invalidCaptionIndexes = invalidIndexesRaw.filter((idx) => idx >= 0);
                    const missingRequiredUpload = selectedIsAfkir && lampiranStatus.length === 0;
                    const isInvalidLampiran = missingRequiredUpload || invalidCaptionIndexes.length > 0;
                    return (
                      <div className={`card page16-soft-card mt-3 ${isInvalidLampiran ? 'border-warning' : 'border-primary-subtle'}`}>
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>{selectedIsAfkir ? 'Upload BA Analisa (wajib)' : 'Upload Dokumen (opsional)'}</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={lampiranStatus}
                            setAttachments={(updater) => {
                              setBeritaAcaraAttachmentsForRow(statusBanTargetRow, updater);
                              clearInvalidBeritaAcaraForKey(lampiranKey);
                            }}
                            bisaInput={true}
                            uploadInputClassName={missingRequiredUpload ? 'bg-warning-subtle border-warning' : ''}
                            invalidCaptionIndexes={invalidCaptionIndexes}
                            onCaptionChange={() => {
                              clearInvalidBeritaAcaraForKey(lampiranKey);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setOpenStatusBanModal(false)}>
                    Tutup
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-warning"
                    onClick={() => setStatusBanDraftNext(String(statusBanTargetRow?.status_awal || '-').trim() || '-')}
                  >
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveStatusBanModal}
                    disabled={!String(statusBanDraftNext || "").trim()}
                  >
                    Selesai
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
	      {openKetLepasModal && (
	        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-md" role="document" style={{ maxWidth: "750px" }}>
	              <div className="modal-content">
	                <div className="modal-header">
	                  <h6 className="modal-title">Keterangan Ganti Ban, Seri {ketLepasTargetRow?.seri_ban || "-"}</h6>
	                  <button type="button" className="btn-close" onClick={() => setOpenKetLepasModal(false)} />
	                </div>
	                <div className="modal-body">
	                  {isRowLepasToGudang(ketLepasTargetRow) && (
	                    <>
	                      <p className="modal-title my-2">Kondisi Ban Saat Lepas:</p>
	                      <div className={`d-flex flex-wrap gap-2 p-2 rounded border ${String(ketLepasDraft || '').trim() ? 'bg-primary-subtle border-primary-subtle' : 'bg-warning-subtle border-warning'}`}>
	                        {BAN_DEFECT_OPTIONS.map((opt) => (
	                          <button
	                            key={`ket-lepas-opt-${opt.label}`}
	                            type="button"
	                            className={`btn btn-sm ${ketLepasDraft === opt.label ? "btn-primary" : "btn-outline-primary"}`}
	                            onClick={() => {
	                              setKetLepasDraft(opt.label);
	                              if (opt.label === 'Normal') setIndikasiDraft('Normal');
	                            }}
	                            onMouseEnter={(e) => positionDefectTooltip(e, `${String(opt.label || "").toUpperCase()}\n${opt.definition}`)}
	                            onMouseMove={(e) => positionDefectTooltip(e, `${String(opt.label || "").toUpperCase()}\n${opt.definition}`)}
	                            onMouseLeave={() => setDefectTooltip({ visible: false, text: "", x: 0, y: 0 })}
	                          >
	                            {opt.label}
	                          </button>
	                        ))}
	                      </div>
	                      <p className="modal-title my-2 mt-3">Indikasi Mekanik:</p>
	                      <div className="d-flex flex-wrap gap-2 p-2 rounded border bg-primary-subtle border-primary-subtle">
	                        {BAN_MECHANICAL_INDICATION_OPTIONS.map((opt) => {
	                          const disableNonNormal = ketLepasDraft === 'Normal' && opt.label !== 'Normal';
	                          return (
	                            <button
	                              key={`ket-indikasi-opt-${opt.label}`}
	                              type="button"
	                              className={`btn btn-sm ${indikasiDraft === opt.label ? "btn-primary" : "btn-outline-primary"}`}
	                              onClick={() => setIndikasiDraft(opt.label)}
	                              onMouseEnter={(e) => positionDefectTooltip(e, `${String(opt.label || "").toUpperCase()}\n${opt.definition}`)}
	                              onMouseMove={(e) => positionDefectTooltip(e, `${String(opt.label || "").toUpperCase()}\n${opt.definition}`)}
	                              onMouseLeave={() => setDefectTooltip({ visible: false, text: "", x: 0, y: 0 })}
	                              disabled={disableNonNormal}
	                            >
	                              {opt.label}
	                            </button>
	                          );
	                        })}
	                      </div>
	                    </>
	                  )}
	                  <p className="modal-title my-2 mt-3">
                            {isRowLepasToGudang(ketLepasTargetRow) ? 'Catatan Lepas (wajib):' : 'Catatan:'}
                          </p>
	                  <textarea
	                    rows={1}
	                    className={`form-control ${isRowLepasToGudang(ketLepasTargetRow) && !String(catatanDraft || '').trim()
                              ? 'bg-warning-subtle border-warning'
                              : 'bg-primary-subtle border-primary'}`}
	                    value={catatanDraft}
	                    onChange={(e) => setCatatanDraft(e.target.value)}
	                    placeholder= {isRowLepasToGudang(ketLepasTargetRow) ? "Alasan Lepas.." : "Catatan ban..."}
	                    aria-invalid={isRowLepasToGudang(ketLepasTargetRow) && !String(catatanDraft || '').trim()}
	                  />
                    {isRowLepasToGudang(ketLepasTargetRow) && (
                      <div className="row g-2 mt-1">
                        <div className="col-md-8">
                          <p className="modal-title my-2">Tindak Lanjut (jika diperlukan):</p>
                          <textarea
                            rows={1}
                            className="form-control bg-primary-subtle border-primary"
                            value={tindakLanjutDraft}
                            onChange={(e) => setTindakLanjutDraft(e.target.value)}
                            placeholder="Tindak lanjut..."
                          />
                        </div>
                        <div className="col-md-4">
                          <p className="modal-title my-2">Nama Sopir:</p>
                          <input
                            type="text"
                            className="form-control bg-primary-subtle border-primary"
                            value={namaSopirDraft}
                            onChange={(e) => setNamaSopirDraft(e.target.value)}
                            placeholder="Nama sopir..."
                          />
                        </div>
                      </div>
                    )}
	                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setOpenKetLepasModal(false)}>
                    Tutup
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveKetLepasModal}>
                    Gunakan
                  </button>
                </div>
              </div>
            </div>
          </div>
          {defectTooltip.visible && (
            <div
              style={{
                position: "fixed",
                left: `${defectTooltip.x}px`,
                top: `${defectTooltip.y}px`,
                zIndex: 2200,
                maxWidth: "320px",
                minWidth: "220px",
                whiteSpace: "pre-line",
                background: "#0f172a",
                color: "#ffffff",
                borderRadius: "8px",
                padding: "8px 10px",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: 1.25,
                boxShadow: "0 10px 22px rgba(15, 23, 42, 0.28)",
                pointerEvents: "none",
              }}
            >
              {defectTooltip.text}
            </div>
          )}
        </>
      )}
      {showPosisiHistoryModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title mb-0">Historical Ban Per Posisi</h5>
                  <small className="text-muted">{mt1Info}</small>
                </div>
                <button type="button" className="btn-close" onClick={() => setShowPosisiHistoryModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-5">
                    <h6 className="mb-2">Pilih Posisi</h6>
                    <FormasiBanDraggable
                      formasi={formasiMt1}
                      cadangan={cadanganMt1}
                      onClick={(pos) => setSelectedHistoryPosisi(String(pos || '').trim())}
                      daftarKodeBan={{}}
                      highlightedPosisi={selectedHistoryPosisi}
                      warningPosisi={[]}
                      unevenWearPosisi={[]}
                      draggable={false}
                    />
                  </div>
                  <div className="col-md-7">
                    <h6 className="mb-2">
                      {selectedHistoryPosisi ? `Historical Posisi ${selectedHistoryPosisi}` : 'Historical Posisi'}
                    </h6>
                    <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                      {loadingPosisiHistory && <div className="text-muted">Memuat historical ban per posisi...</div>}
                      {!loadingPosisiHistory && !(posisiHistoryMap?.[selectedHistoryPosisi]?.length) && (
                        <div className="text-muted">Belum ada historical ban pada posisi ini.</div>
                      )}
                      {!loadingPosisiHistory && (posisiHistoryMap?.[selectedHistoryPosisi] || []).map((row, idx) => (
                        <div key={`${row?.id_ban || 'ban'}-${row?.tanggal || '-'}-${idx}`} className="card mb-2">
                          <div className="card-body py-2">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className={`page9show-chip is-${getEventVariant(row?.event)}`}>
                                {String(row?.event || '-').toUpperCase()}
                              </span>
                              <small className="text-muted">{`(${formatTglUntukUI(row?.tanggal)})`}</small>
                            </div>
                            <div className="row g-1 small">
                              <div className="col-6"><strong>ID Ban:</strong> {row?.id_ban || '-'}</div>
                              <div className="col-6"><strong>Status:</strong> {row?.status || '-'}</div>
                              <div className="col-6"><strong>Seri Ban:</strong> {row?.seri_ban || '-'}</div>
                              <div className="col-6"><strong>Merk:</strong> {row?.merk || '-'}</div>
                              <div className="col-6"><strong>Ukuran:</strong> {row?.ukuran || '-'}</div>
                              <div className="col-6"><strong>Cabang:</strong> {mapCabang[String(row?.kode_cabang || '').trim()] || row?.kode_cabang || '-'}</div>
                              <div className="col-6"><strong>KMT:</strong> {Number(row?.kmt || 0)}</div>
                              {String(row?.info || '').trim() ? (
                                <div className="col-12"><strong>Info:</strong> {String(row?.info || '').trim()}</div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowPosisiHistoryModal(false)}>
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
)}

function StatRow ({ label, secondaryLabel = '', value, onClick, variant = 'neutral', rightContent = null }) {
  const clickable = typeof onClick === 'function';
  const rowClickable = clickable && Boolean(rightContent);
  return (
    <div
      className="page9show-row"
      onClick={rowClickable ? onClick : undefined}
      role={rowClickable ? 'button' : undefined}
      tabIndex={rowClickable ? 0 : undefined}
      onKeyDown={rowClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick();
      } : undefined}
      style={rowClickable ? { cursor: 'pointer' } : undefined}
    >
      <div className="page9show-row-text">
        <span className="page9show-row-label">{label}</span>
        {secondaryLabel ? <small className="page9show-row-secondary">{secondaryLabel}</small> : null}
      </div>
      {rightContent ? (
        <div className="page9show-icon-wrap">{rightContent}</div>
      ) : (
        <button
          type="button"
          className={`page9show-chip is-${variant}`}
          onClick={clickable ? onClick : undefined}
          disabled={!clickable}
        >
          {value}
        </button>
      )}
    </div>
  );
}

function LampiranTypeBadge({ isImage }) {
  return (
    <span className={`page9show-icon-badge ${isImage ? 'is-image' : 'is-doc'}`} title={isImage ? 'Gambar' : 'Dokumen'}>
      {isImage ? (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm2 0v10.2l3.1-3.1a1 1 0 0 1 1.4 0l2.4 2.4l2.6-2.6a1 1 0 0 1 1.4 0L18 13.1V5H6Zm2.8 4.5a1.7 1.7 0 1 0 0-3.4a1.7 1.7 0 0 0 0 3.4Z"/>
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.5L14.5 2H7Zm7 1.5L18.5 8H14V3.5ZM8 12a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2H8Zm0 4a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2H8Z"/>
        </svg>
      )}
    </span>
  );
}
